import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  /** An ISO 8601-encoded date */
  Date: string;
  /** An ISO 8601-encoded datetime */
  DateTime: string;
  Duration: string;
  /** Represents an email */
  Email: string;
  Hash: string;
  /** Represents untyped JSON */
  JSON: string;
  UnitTypes: any;
};

export type Account = {
  readonly __typename?: 'Account';
  readonly customer: Customer;
  readonly id: Scalars['ID'];
};

export type ActiveStorageAttachment = {
  readonly __typename?: 'ActiveStorageAttachment';
  readonly filename: Scalars['String'];
  readonly id: Scalars['String'];
  readonly imgixURL: Scalars['String'];
  readonly url: Scalars['String'];
};

export type Address = {
  readonly __typename?: 'Address';
  readonly aptsuite?: Maybe<Scalars['String']>;
  readonly city: Scalars['String'];
  readonly id: Scalars['ID'];
  readonly latitude?: Maybe<Scalars['Float']>;
  readonly longitude?: Maybe<Scalars['Float']>;
  readonly serviceable: Scalars['Boolean'];
  readonly state: Scalars['String'];
  readonly street: Scalars['String'];
  readonly zip: Scalars['String'];
};

export type AddressDetailInput = {
  readonly buildingType?: InputMaybe<Moving__BuildingTypeEnum>;
  readonly code?: InputMaybe<Scalars['Boolean']>;
  readonly loadingDock?: InputMaybe<Scalars['Boolean']>;
  readonly longCarry?: InputMaybe<Scalars['Boolean']>;
  readonly parkingAlley?: InputMaybe<Scalars['Boolean']>;
  readonly parkingDriveway?: InputMaybe<Scalars['Boolean']>;
  readonly parkingInFront?: InputMaybe<Scalars['Boolean']>;
  readonly parkingInstructions?: InputMaybe<Scalars['String']>;
  readonly parkingLot?: InputMaybe<Scalars['Boolean']>;
  readonly parkingPermit?: InputMaybe<Scalars['Boolean']>;
  readonly parkingUnknown?: InputMaybe<Scalars['Boolean']>;
  readonly serviceEntrance?: InputMaybe<Scalars['Boolean']>;
  readonly steep?: InputMaybe<Scalars['Boolean']>;
};

export type AddressInput = {
  readonly aptsuite?: InputMaybe<Scalars['String']>;
  readonly businessName?: InputMaybe<Scalars['String']>;
  readonly city: Scalars['String'];
  readonly country?: InputMaybe<Scalars['String']>;
  readonly details?: InputMaybe<AddressDetailInput>;
  readonly latitude?: InputMaybe<Scalars['Float']>;
  readonly longitude?: InputMaybe<Scalars['Float']>;
  readonly state: Scalars['String'];
  readonly street: Scalars['String'];
  readonly zip: Scalars['String'];
};

export type AppointmentQuote = {
  readonly __typename?: 'AppointmentQuote';
  readonly id: Scalars['ID'];
};

/** Autogenerated return type of AppointmentQuoteCreate */
export type AppointmentQuoteCreatePayload = {
  readonly __typename?: 'AppointmentQuoteCreatePayload';
  readonly error?: Maybe<Scalars['String']>;
  readonly finalPackageSetEntries: ReadonlyArray<PackageSetEntry>;
  readonly laborRate: LaborRate;
  readonly onboardingPackageSetEntries: ReadonlyArray<PackageSetEntry>;
  readonly quote?: Maybe<AppointmentQuote>;
  readonly status: Status;
};

export type AvailabilitiesInput = {
  readonly from: Scalars['DateTime'];
  readonly movingQuoteSignedID?: InputMaybe<Scalars['ID']>;
  readonly onboardingTimeSlotSelectionFeeEligible?: InputMaybe<Scalars['Boolean']>;
  readonly order: AvailabilitiesOrderInput;
  readonly till: Scalars['DateTime'];
};

export type AvailabilitiesOrderInput = {
  readonly address: AddressInput;
  readonly expectedPlanID?: InputMaybe<Scalars['ID']>;
  readonly movers?: InputMaybe<Scalars['Int']>;
  readonly serviceType?: InputMaybe<OrderServiceTypeEnum>;
  readonly subtype?: InputMaybe<OrderSubtypeEnum>;
  readonly type: OrderTypeEnum;
};

export type Availability = {
  readonly __typename?: 'Availability';
  readonly available: Scalars['Boolean'];
  readonly datetime: Scalars['DateTime'];
  readonly duration?: Maybe<Scalars['Duration']>;
  readonly feeAmount?: Maybe<MonetaryAmount>;
  /** Formatted window (9:00 AM - 10:00 AM). */
  readonly formatted: Scalars['String'];
  readonly formattedFromTime: Scalars['String'];
  readonly fromTime: Scalars['DateTime'];
  readonly tillTime: Scalars['DateTime'];
};

export type CalculatePackageSetEntryAmountInterface = {
  readonly calculatePackageSetEntryAmount?: Maybe<Scalars['Int']>;
};


export type CalculatePackageSetEntryAmountInterfaceCalculatePackageSetEntryAmountArgs = {
  cuft: Scalars['Float'];
  packageKind: Scalars['String'];
  packageSetName: Scalars['String'];
};

export enum CallbackDepartment {
  Minimoves = 'MINIMOVES',
  Sales = 'SALES'
}

export type CallbackWindow = {
  readonly __typename?: 'CallbackWindow';
  readonly duration: Scalars['Duration'];
  readonly time: Scalars['DateTime'];
};

export type Coupon = {
  readonly __typename?: 'Coupon';
  readonly amount: Scalars['Float'];
  readonly code: Scalars['String'];
  readonly discountDescription: Scalars['String'];
  readonly discountDisclaimer?: Maybe<Scalars['String']>;
  readonly duration: CouponDurationTypeEnum;
  readonly id: Scalars['ID'];
  readonly movingEligible: Scalars['Boolean'];
  readonly name: Scalars['String'];
  readonly percent: Scalars['Float'];
  readonly scheduledCutoff?: Maybe<Scalars['Date']>;
  readonly subject: Coupon__Subject;
};

export enum Coupon__Subject {
  Credit = 'CREDIT',
  Order = 'ORDER',
  Subscription = 'SUBSCRIPTION'
}

export enum CouponDurationTypeEnum {
  Forever = 'FOREVER',
  Once = 'ONCE',
  Repeating = 'REPEATING'
}

export type CouponOrError = Coupon | Error;

export enum Currency {
  Cad = 'CAD',
  Usd = 'USD'
}

export type Customer = {
  readonly __typename?: 'Customer';
  readonly address?: Maybe<Address>;
  readonly currentStorageCustomer: Scalars['Boolean'];
  readonly defaultSource?: Maybe<Source>;
  readonly email: Scalars['String'];
  readonly id: Scalars['ID'];
  readonly name: Scalars['String'];
  readonly phone?: Maybe<Scalars['String']>;
  readonly token: Scalars['String'];
};

export enum CustomerTicket__ContactPreference {
  Chat = 'CHAT',
  Email = 'EMAIL',
  Phone = 'PHONE'
}

export type Disposal__CategoryPricingDescriptor = {
  readonly __typename?: 'Disposal__CategoryPricingDescriptor';
  readonly category: Scalars['String'];
  readonly id: Scalars['ID'];
  readonly minimum: Scalars['Float'];
};

export enum DoorToDoor__BundleEnum {
  Basic = 'BASIC',
  PickupAndPacking = 'PICKUP_AND_PACKING'
}

/** Autogenerated return type of DoorToDoor__Onboarding__Create */
export type DoorToDoor__Onboarding__CreatePayload = {
  readonly __typename?: 'DoorToDoor__Onboarding__CreatePayload';
  readonly accountPortalUrl?: Maybe<Scalars['String']>;
  readonly error?: Maybe<Error>;
  readonly orderID?: Maybe<Scalars['ID']>;
  readonly orderToken?: Maybe<Scalars['String']>;
  readonly status: Status;
};

export type DoorToDoor__OnboardingInputType = {
  readonly bundleKind?: InputMaybe<DoorToDoor__BundleEnum>;
  readonly customerToken?: InputMaybe<Scalars['String']>;
  readonly date?: InputMaybe<Scalars['String']>;
  readonly disposalRequested?: InputMaybe<Scalars['Boolean']>;
  readonly email?: InputMaybe<Scalars['Email']>;
  readonly incentive?: InputMaybe<IncentiveInput>;
  readonly marketingData?: InputMaybe<MarketingDataInput>;
  readonly moverCount?: InputMaybe<Scalars['Int']>;
  readonly name?: InputMaybe<Scalars['String']>;
  readonly phone?: InputMaybe<Scalars['String']>;
  readonly pickupAddress?: InputMaybe<AddressInput>;
  readonly planID: Scalars['ID'];
  readonly pricing: DoorToDoor__OnboardingPricingInputType;
  readonly promoCode?: InputMaybe<Scalars['String']>;
  readonly protectionPlanSlug?: InputMaybe<Scalars['String']>;
  readonly rateGroupID: Scalars['ID'];
  readonly slaWindowDuration?: InputMaybe<Scalars['Duration']>;
  readonly stripeToken?: InputMaybe<Scalars['String']>;
  readonly subsource?: InputMaybe<Scalars['String']>;
  readonly userID?: InputMaybe<Scalars['ID']>;
  readonly visitorToken: Scalars['String'];
};

export type DoorToDoor__OnboardingPricingInputType = {
  readonly appointmentQuoteID?: InputMaybe<Scalars['ID']>;
  readonly laborBillingFormat: Scalars['String'];
  readonly laborPolicyID: Scalars['ID'];
  readonly laborRateID: Scalars['ID'];
  readonly packageSetEntries?: InputMaybe<ReadonlyArray<PackageSetEntryInput>>;
  readonly quoteID: Scalars['ID'];
};

export type DoorToDoorMutationInterface = {
  readonly doorToDoorOnboardingReserve?: Maybe<DoorToDoor__Onboarding__CreatePayload>;
};


export type DoorToDoorMutationInterfaceDoorToDoorOnboardingReserveArgs = {
  input: DoorToDoor__OnboardingInputType;
};

export type Draft = {
  readonly __typename?: 'Draft';
  readonly address?: Maybe<Draft__Address>;
  readonly id: Scalars['ID'];
  readonly latestService?: Maybe<Lead__ServiceNeeds>;
  readonly lead?: Maybe<Lead>;
  readonly moverCount?: Maybe<Scalars['Int']>;
  readonly movingDestinationAttributes?: Maybe<Draft__MovingAddress>;
  readonly movingOriginAttributes?: Maybe<Draft__MovingAddress>;
  readonly movingQuote?: Maybe<Moving__QuoteType>;
  readonly movingQuoteStartedAt?: Maybe<Scalars['DateTime']>;
  readonly plan?: Maybe<Draft__Plan>;
  readonly preferredTime?: Maybe<Scalars['DateTime']>;
  readonly protectionPlanSlug?: Maybe<Scalars['String']>;
  readonly rateGroup?: Maybe<RateGroup>;
  readonly storageQuoteStartedAt?: Maybe<Scalars['DateTime']>;
};

export type Draft__Address = {
  readonly __typename?: 'Draft__Address';
  readonly aptsuite?: Maybe<Scalars['String']>;
  readonly city?: Maybe<Scalars['String']>;
  readonly latitude?: Maybe<Scalars['Float']>;
  readonly longitude?: Maybe<Scalars['Float']>;
  readonly state?: Maybe<Scalars['String']>;
  readonly street?: Maybe<Scalars['String']>;
  readonly zip?: Maybe<Scalars['String']>;
};

export type Draft__AddressInput = {
  readonly aptsuite?: InputMaybe<Scalars['String']>;
  readonly city?: InputMaybe<Scalars['String']>;
  readonly state?: InputMaybe<Scalars['String']>;
  readonly street?: InputMaybe<Scalars['String']>;
  readonly zip: Scalars['String'];
};

export type Draft__MovingAddress = {
  readonly __typename?: 'Draft__MovingAddress';
  readonly access?: Maybe<Scalars['String']>;
  readonly aptsuite?: Maybe<Scalars['String']>;
  readonly buildingType?: Maybe<Moving__BuildingTypeEnum>;
  readonly city?: Maybe<Scalars['String']>;
  readonly floor?: Maybe<Scalars['Int']>;
  readonly googleAddressType?: Maybe<Scalars['String']>;
  readonly latitude?: Maybe<Scalars['Float']>;
  readonly longCarry?: Maybe<Scalars['Boolean']>;
  readonly longitude?: Maybe<Scalars['Float']>;
  readonly squareFootage?: Maybe<Scalars['Int']>;
  readonly state?: Maybe<Scalars['String']>;
  readonly stories?: Maybe<Scalars['Int']>;
  readonly street?: Maybe<Scalars['String']>;
  readonly unitSize?: Maybe<Scalars['String']>;
  readonly zip?: Maybe<Scalars['String']>;
};

export type Draft__MovingAddressInput = {
  readonly access?: InputMaybe<Scalars['String']>;
  readonly aptsuite?: InputMaybe<Scalars['String']>;
  readonly buildingType?: InputMaybe<Moving__BuildingTypeEnum>;
  readonly city?: InputMaybe<Scalars['String']>;
  readonly floor?: InputMaybe<Scalars['Int']>;
  readonly googleAddressType?: InputMaybe<Scalars['String']>;
  readonly latitude?: InputMaybe<Scalars['Float']>;
  readonly longCarry?: InputMaybe<Scalars['Boolean']>;
  readonly longitude?: InputMaybe<Scalars['Float']>;
  readonly squareFootage?: InputMaybe<Scalars['Int']>;
  readonly state?: InputMaybe<Scalars['String']>;
  readonly stories?: InputMaybe<Scalars['Int']>;
  readonly street?: InputMaybe<Scalars['String']>;
  readonly unitSize?: InputMaybe<Scalars['String']>;
  readonly zip: Scalars['String'];
};

export type Draft__Plan = {
  readonly __typename?: 'Draft__Plan';
  readonly name?: Maybe<Scalars['String']>;
};

export type DraftInput = {
  readonly address?: InputMaybe<Draft__AddressInput>;
  readonly latestService?: InputMaybe<Lead__ServiceNeeds>;
  readonly leadToken?: InputMaybe<Scalars['ID']>;
  /** Requested number of movers on storage onboarding */
  readonly moverCount?: InputMaybe<Scalars['Int']>;
  readonly movingDestinationAttributes?: InputMaybe<Draft__MovingAddressInput>;
  readonly movingOriginAttributes?: InputMaybe<Draft__MovingAddressInput>;
  readonly movingQuoteID?: InputMaybe<Scalars['ID']>;
  readonly preferredTime?: InputMaybe<Scalars['DateTime']>;
  readonly protectionPlanSlug?: InputMaybe<Scalars['String']>;
  readonly quoteID?: InputMaybe<Scalars['ID']>;
  readonly rateGroupID?: InputMaybe<Scalars['ID']>;
  readonly storagePlanID?: InputMaybe<Scalars['ID']>;
  readonly storagePlanQuantity?: InputMaybe<Scalars['Int']>;
  readonly visitorToken: Scalars['ID'];
};

/** Autogenerated return type of DraftUpsert */
export type DraftUpsertPayload = {
  readonly __typename?: 'DraftUpsertPayload';
  readonly draft: Draft;
  readonly status: Status;
};

export type Error = {
  readonly __typename?: 'Error';
  readonly code: ErrorCodeEnum;
  readonly expected?: Maybe<Scalars['Boolean']>;
  readonly message: Scalars['String'];
};

export enum ErrorCodeEnum {
  ActiveStorageAccount = 'ACTIVE_STORAGE_ACCOUNT',
  BannedAccount = 'BANNED_ACCOUNT',
  CardError = 'CARD_ERROR',
  CouponNotEligible = 'COUPON_NOT_ELIGIBLE',
  CouponNotFound = 'COUPON_NOT_FOUND',
  ExistingCoupon = 'EXISTING_COUPON',
  ExistingCustomer = 'EXISTING_CUSTOMER',
  ExistingPaidReferral = 'EXISTING_PAID_REFERRAL',
  ExistingPendingReferral = 'EXISTING_PENDING_REFERRAL',
  InvalidEmail = 'INVALID_EMAIL',
  InvalidPhone = 'INVALID_PHONE',
  InvalidToken = 'INVALID_TOKEN',
  InvalidZip = 'INVALID_ZIP',
  MismatchedCustomer = 'MISMATCHED_CUSTOMER',
  PastNextDayCutoff = 'PAST_NEXT_DAY_CUTOFF',
  PendingStorageOnboarding = 'PENDING_STORAGE_ONBOARDING',
  PhoneNotSupported = 'PHONE_NOT_SUPPORTED',
  PromoCodeNotRedeemable = 'PROMO_CODE_NOT_REDEEMABLE',
  SuspendedAccount = 'SUSPENDED_ACCOUNT',
  UnitNotAvailable = 'UNIT_NOT_AVAILABLE',
  Unknown = 'UNKNOWN',
  UnsafeAddress = 'UNSAFE_ADDRESS',
  ZendeskApiError = 'ZENDESK_API_ERROR'
}

export type Estimation__ItemCategory = {
  readonly __typename?: 'Estimation__ItemCategory';
  readonly cuft: Scalars['Float'];
  readonly id: Scalars['ID'];
  readonly name: Scalars['String'];
};

export type EstimationQueryInterface = {
  readonly commonItemCategories: ReadonlyArray<Estimation__ItemCategory>;
  readonly itemCategorySearch: ReadonlyArray<Estimation__ItemCategory>;
};


export type EstimationQueryInterfaceItemCategorySearchArgs = {
  query: Scalars['String'];
};

export type FinalReturnCostSummary = {
  readonly __typename?: 'FinalReturnCostSummary';
  readonly freeDuration?: Maybe<Scalars['Duration']>;
  readonly id: Scalars['ID'];
  readonly laborRate: LaborRate;
  readonly planId: Scalars['ID'];
  readonly rateGroupKind: RateGroupKindEnum;
};

export type FlowStepTransitionInput = {
  readonly actionName: Scalars['String'];
  readonly allData?: InputMaybe<Scalars['JSON']>;
  readonly data?: InputMaybe<Scalars['JSON']>;
  readonly flowInstanceUuid: Scalars['String'];
  readonly flowName: Scalars['String'];
  readonly flowVersion: Scalars['String'];
  readonly metadata?: InputMaybe<Scalars['JSON']>;
  readonly name: Scalars['String'];
  readonly pageUuid: Scalars['String'];
  readonly position: Scalars['Int'];
  readonly resourceToken: Scalars['String'];
  readonly resourceType: Scalars['String'];
};

/** Autogenerated return type of FlowStepTransition */
export type FlowStepTransitionPayload = {
  readonly __typename?: 'FlowStepTransitionPayload';
  readonly status: Status;
};

export type Geocode = {
  readonly __typename?: 'Geocode';
  readonly center?: Maybe<LocatablePoint>;
  readonly cityName?: Maybe<Scalars['String']>;
  readonly eligibleForDisposal: Scalars['Boolean'];
  readonly eligibleForDoorToDoor: Scalars['Boolean'];
  readonly eligibleForMoving: Scalars['Boolean'];
  readonly extendedMovingServiceArea: Scalars['Boolean'];
  readonly id: Scalars['ID'];
  readonly nearestSelfStorageFacilities?: Maybe<ReadonlyArray<SelfStorage__Facility>>;
  readonly nearestSelfStorageFacility?: Maybe<SelfStorage__Facility>;
  readonly nearestThirdPartyFacilities: ReadonlyArray<SelfStorage__Facility>;
  readonly region?: Maybe<Region>;
};

export type IncentiveInput = {
  readonly eligible: Scalars['Boolean'];
};

export type IntegerRange = {
  readonly __typename?: 'IntegerRange';
  readonly begin?: Maybe<Scalars['Int']>;
  readonly end?: Maybe<Scalars['Int']>;
};

export enum LaborBillingFormatEnum {
  PerAppointmentHour = 'per_appointment_hour',
  PerMoverHour = 'per_mover_hour'
}

export type LaborPolicy = {
  readonly __typename?: 'LaborPolicy';
  readonly id: Scalars['ID'];
  readonly laborBillingFormat: LaborBillingFormatEnum;
  readonly laborRate: LaborRate;
  readonly perItemPricing: Scalars['Boolean'];
};

export type LaborRate = {
  readonly __typename?: 'LaborRate';
  readonly amount: Scalars['Float'];
  readonly id: Scalars['ID'];
  readonly name: Scalars['String'];
};

export type Landing__Location__Route = {
  readonly __typename?: 'Landing__Location__Route';
  readonly content?: Maybe<Location__Content>;
  readonly createdAt: Scalars['DateTime'];
  readonly destination: RouteLocation;
  readonly id: Scalars['ID'];
  readonly origin: RouteLocation;
  readonly slug: Scalars['ID'];
  readonly updatedAt: Scalars['DateTime'];
};


export type Landing__Location__RouteContentArgs = {
  service: Location__Service;
};

export type Lead = {
  readonly __typename?: 'Lead';
  readonly accountID?: Maybe<Scalars['ID']>;
  readonly currentStorageCustomer: Scalars['Boolean'];
  readonly draft?: Maybe<Draft>;
  readonly email?: Maybe<Scalars['String']>;
  readonly id: Scalars['ID'];
  readonly name?: Maybe<Scalars['String']>;
  readonly phone?: Maybe<Scalars['String']>;
  readonly token: Scalars['String'];
  readonly zip?: Maybe<Scalars['String']>;
};

export enum Lead__ServiceNeeds {
  Containers = 'CONTAINERS',
  Moving = 'MOVING',
  SelfStorage = 'SELF_STORAGE',
  SmartStorage = 'SMART_STORAGE'
}

/** Autogenerated return type of LeadCreate */
export type LeadCreatePayload = {
  readonly __typename?: 'LeadCreatePayload';
  readonly error?: Maybe<Error>;
  readonly lead?: Maybe<Lead>;
  readonly status: Status;
};

export type LeadInput = {
  readonly customerToken?: InputMaybe<Scalars['String']>;
  readonly email?: InputMaybe<Scalars['Email']>;
  readonly name?: InputMaybe<Scalars['String']>;
  readonly phone?: InputMaybe<Scalars['String']>;
  readonly serviceNeeds?: InputMaybe<ReadonlyArray<Lead__ServiceNeeds>>;
  readonly source?: InputMaybe<Scalars['String']>;
  readonly state?: InputMaybe<Scalars['String']>;
  readonly url: Scalars['String'];
  readonly wtPageUuid?: InputMaybe<Scalars['String']>;
  readonly zip?: InputMaybe<Scalars['String']>;
};

export type LocatableBoundsInput = {
  readonly northEastPoint: LocatablePointInput;
  readonly southWestPoint: LocatablePointInput;
};

export type LocatablePoint = {
  readonly __typename?: 'LocatablePoint';
  readonly latitude: Scalars['Float'];
  readonly longitude: Scalars['Float'];
};

export type LocatablePointInput = {
  readonly latitude: Scalars['Float'];
  readonly longitude: Scalars['Float'];
};

export type Location__City = {
  readonly __typename?: 'Location__City';
  readonly center: LocatablePoint;
  readonly content?: Maybe<Location__Content>;
  readonly createdAt: Scalars['DateTime'];
  readonly id: Scalars['ID'];
  readonly name: Scalars['String'];
  readonly neighborhood?: Maybe<Location__Neighborhood>;
  readonly neighborhoods: ReadonlyArray<Location__Neighborhood>;
  readonly polygons: ReadonlyArray<Polygon>;
  readonly services: ReadonlyArray<Location__Service>;
  readonly slug: Scalars['ID'];
  readonly state: Location__State;
  readonly updatedAt: Scalars['DateTime'];
};


export type Location__CityContentArgs = {
  service: Location__Service;
};


export type Location__CityNeighborhoodArgs = {
  slug: Scalars['ID'];
};

export type Location__Content = {
  readonly __typename?: 'Location__Content';
  readonly blurb: Scalars['ID'];
  readonly createdAt: Scalars['DateTime'];
  readonly description?: Maybe<Scalars['String']>;
  readonly headline?: Maybe<Scalars['String']>;
  readonly heroAlt?: Maybe<Scalars['String']>;
  readonly heroImage?: Maybe<ActiveStorageAttachment>;
  readonly id: Scalars['ID'];
  readonly reviews: ReadonlyArray<Location__Review>;
  readonly service: Location__Service;
  readonly title?: Maybe<Scalars['String']>;
  readonly updatedAt: Scalars['DateTime'];
};

export type Location__Neighborhood = {
  readonly __typename?: 'Location__Neighborhood';
  readonly city: Location__City;
  readonly content?: Maybe<Location__Content>;
  readonly createdAt: Scalars['DateTime'];
  readonly id: Scalars['ID'];
  readonly name: Scalars['String'];
  readonly slug: Scalars['ID'];
  readonly updatedAt: Scalars['DateTime'];
};


export type Location__NeighborhoodContentArgs = {
  service: Location__Service;
};

export type Location__Review = {
  readonly __typename?: 'Location__Review';
  readonly author: Scalars['String'];
  readonly createdAt: Scalars['DateTime'];
  readonly id: Scalars['ID'];
  readonly message: Scalars['String'];
  readonly rating: Scalars['Int'];
  readonly updatedAt: Scalars['DateTime'];
};

export enum Location__Service {
  Moving = 'MOVING',
  SelfStorage = 'SELF_STORAGE',
  SmartStorage = 'SMART_STORAGE'
}

export type Location__State = {
  readonly __typename?: 'Location__State';
  readonly cities: ReadonlyArray<Location__City>;
  readonly city?: Maybe<Location__City>;
  readonly code: Scalars['String'];
  readonly createdAt: Scalars['DateTime'];
  readonly id: Scalars['ID'];
  readonly name: Scalars['String'];
  readonly slug: Scalars['ID'];
  readonly updatedAt: Scalars['DateTime'];
};


export type Location__StateCityArgs = {
  slug: Scalars['ID'];
};

export type LocationsQueryInterface = {
  readonly route?: Maybe<Landing__Location__Route>;
  readonly routes: ReadonlyArray<Landing__Location__Route>;
  readonly state?: Maybe<Location__State>;
  readonly states: ReadonlyArray<Location__State>;
};


export type LocationsQueryInterfaceRouteArgs = {
  slug: Scalars['ID'];
};


export type LocationsQueryInterfaceRoutesArgs = {
  featured?: InputMaybe<Scalars['Boolean']>;
};


export type LocationsQueryInterfaceStateArgs = {
  slug: Scalars['ID'];
};

export type MarketingDataInput = {
  readonly channel?: InputMaybe<Scalars['String']>;
  readonly impactClickID?: InputMaybe<Scalars['String']>;
};

export type Mfa__AttemptInput = {
  readonly code: Scalars['String'];
  readonly lead: LeadInput;
  readonly requestID: Scalars['ID'];
};

/** Autogenerated return type of MFA__MakeAttempt */
export type Mfa__MakeAttemptPayload = {
  readonly __typename?: 'MFA__MakeAttemptPayload';
  readonly customer?: Maybe<Customer>;
  readonly error?: Maybe<Scalars['String']>;
  readonly lead?: Maybe<Lead>;
  readonly status: Status;
};

export type Mfa__Request = {
  readonly __typename?: 'MFA__Request';
  readonly id: Scalars['ID'];
};

/** Autogenerated return type of MFA__RequestCreate */
export type Mfa__RequestCreatePayload = {
  readonly __typename?: 'MFA__RequestCreatePayload';
  readonly error?: Maybe<Scalars['String']>;
  readonly request?: Maybe<Mfa__Request>;
  readonly status: Status;
};

export type Mfa__RequestInput = {
  readonly email: Scalars['Email'];
};

export type MfaMutationInterface = {
  readonly mfaAttemptMake?: Maybe<Mfa__MakeAttemptPayload>;
  readonly mfaRequestCreate?: Maybe<Mfa__RequestCreatePayload>;
};


export type MfaMutationInterfaceMfaAttemptMakeArgs = {
  input: Mfa__AttemptInput;
};


export type MfaMutationInterfaceMfaRequestCreateArgs = {
  input: Mfa__RequestInput;
};

export type MonetaryAmount = {
  readonly __typename?: 'MonetaryAmount';
  readonly currency: Currency;
  readonly formatted: Scalars['String'];
  readonly value: Scalars['Float'];
};

export type Moving__Address = {
  readonly __typename?: 'Moving__Address';
  readonly aptsuite?: Maybe<Scalars['String']>;
  readonly city?: Maybe<Scalars['String']>;
  readonly details?: Maybe<Moving__AddressDetail>;
  readonly state?: Maybe<Scalars['String']>;
  readonly street?: Maybe<Scalars['String']>;
  readonly zip?: Maybe<Scalars['String']>;
};

export type Moving__AddressDetail = {
  readonly __typename?: 'Moving__AddressDetail';
  readonly buildingType: Moving__BuildingTypeEnum;
  readonly code?: Maybe<Scalars['Boolean']>;
  readonly elevator?: Maybe<Scalars['Boolean']>;
  readonly floor: Scalars['Int'];
  readonly loadingDock?: Maybe<Scalars['Boolean']>;
  readonly longCarry: Scalars['Boolean'];
  readonly parkingAlley?: Maybe<Scalars['Boolean']>;
  readonly parkingDriveway?: Maybe<Scalars['Boolean']>;
  readonly parkingInFront?: Maybe<Scalars['Boolean']>;
  readonly parkingInstructions?: Maybe<Scalars['String']>;
  readonly parkingLot?: Maybe<Scalars['Boolean']>;
  readonly parkingPermit?: Maybe<Scalars['Boolean']>;
  readonly parkingUnknown?: Maybe<Scalars['Boolean']>;
  readonly serviceElevator?: Maybe<Scalars['Boolean']>;
  readonly serviceEntrance?: Maybe<Scalars['Boolean']>;
  readonly stairs?: Maybe<Scalars['Boolean']>;
  readonly steep?: Maybe<Scalars['Boolean']>;
  readonly stories: Scalars['Int'];
};

export type Moving__AddressDetailInput = {
  readonly buildingType: Moving__BuildingTypeEnum;
  readonly code?: InputMaybe<Scalars['Boolean']>;
  readonly elevator?: InputMaybe<Scalars['Boolean']>;
  readonly floor: Scalars['Int'];
  readonly loadingDock?: InputMaybe<Scalars['Boolean']>;
  readonly longCarry?: InputMaybe<Scalars['Boolean']>;
  readonly parkingAlley?: InputMaybe<Scalars['Boolean']>;
  readonly parkingDriveway?: InputMaybe<Scalars['Boolean']>;
  readonly parkingInFront?: InputMaybe<Scalars['Boolean']>;
  readonly parkingInstructions?: InputMaybe<Scalars['String']>;
  readonly parkingLot?: InputMaybe<Scalars['Boolean']>;
  readonly parkingPermit?: InputMaybe<Scalars['Boolean']>;
  readonly parkingUnknown?: InputMaybe<Scalars['Boolean']>;
  readonly serviceElevator?: InputMaybe<Scalars['Boolean']>;
  readonly serviceEntrance?: InputMaybe<Scalars['Boolean']>;
  readonly stairs?: InputMaybe<Scalars['Boolean']>;
  readonly steep?: InputMaybe<Scalars['Boolean']>;
  readonly stories: Scalars['Int'];
};

export type Moving__AddressInput = {
  readonly aptsuite?: InputMaybe<Scalars['String']>;
  readonly businessName?: InputMaybe<Scalars['String']>;
  readonly city: Scalars['String'];
  readonly details: Moving__AddressDetailInput;
  readonly state: Scalars['String'];
  readonly street: Scalars['String'];
  readonly zip: Scalars['String'];
};

export enum Moving__BuildingTypeEnum {
  Apartment = 'APARTMENT',
  Commercial = 'COMMERCIAL',
  DonationCenter = 'DONATION_CENTER',
  DormOrCampusApartment = 'DORM_OR_CAMPUS_APARTMENT',
  House = 'HOUSE',
  Other = 'OTHER',
  StorageFacilityOrWarehouse = 'STORAGE_FACILITY_OR_WAREHOUSE',
  Studio = 'STUDIO',
  Townhouse = 'TOWNHOUSE'
}

export type Moving__FinancingInputType = {
  readonly estimatedAmount: Scalars['Float'];
  readonly intended: Scalars['Boolean'];
};

export type Moving__FlatRateDetails = {
  readonly __typename?: 'Moving__FlatRateDetails';
  readonly laborAmount: Scalars['Float'];
  readonly materialsAmount: Scalars['Float'];
  readonly totalAmount: Scalars['Float'];
  readonly transportFeeAmount: Scalars['Float'];
};

export type Moving__LongDistance__TransportationRate = {
  readonly __typename?: 'Moving__LongDistance__TransportationRate';
  readonly id: Scalars['ID'];
  readonly pricePerPound: Scalars['Float'];
  readonly weightInPounds: IntegerRange;
};

/** Autogenerated return type of Moving__MaterialPackageSetEntriesFetch */
export type Moving__MaterialPackageSetEntriesFetchPayload = {
  readonly __typename?: 'Moving__MaterialPackageSetEntriesFetchPayload';
  readonly error?: Maybe<Scalars['String']>;
  readonly materialPackageSetEntries: ReadonlyArray<Moving__PackageSetEntry>;
  readonly status: Status;
};

/** Autogenerated return type of Moving__MoveCreate */
export type Moving__MoveCreatePayload = {
  readonly __typename?: 'Moving__MoveCreatePayload';
  readonly accountPortalUrl?: Maybe<Scalars['String']>;
  readonly error?: Maybe<Error>;
  readonly isExistingCustomer?: Maybe<Scalars['Boolean']>;
  readonly orderID?: Maybe<Scalars['ID']>;
  readonly orderToken?: Maybe<Scalars['String']>;
  readonly status: Status;
};

export type Moving__MoveInput = {
  readonly customerToken?: InputMaybe<Scalars['String']>;
  readonly destinationAddress: Moving__AddressInput;
  readonly disposalRequested?: InputMaybe<Scalars['Boolean']>;
  readonly email: Scalars['Email'];
  readonly financingIntent?: InputMaybe<Moving__FinancingInputType>;
  readonly flatRate?: InputMaybe<Scalars['Boolean']>;
  readonly freeStorage?: InputMaybe<Scalars['Boolean']>;
  readonly laborRateID?: InputMaybe<Scalars['ID']>;
  readonly leadToken: Scalars['String'];
  readonly marketingData?: InputMaybe<MarketingDataInput>;
  readonly moverOverride?: InputMaybe<Scalars['Int']>;
  readonly moveSize?: InputMaybe<Moving__MoveSizeEnum>;
  readonly movingConfigurationID?: InputMaybe<Scalars['ID']>;
  readonly movingQuoteSignedID: Scalars['ID'];
  readonly name: Scalars['String'];
  readonly originAddress: Moving__AddressInput;
  readonly packageSetEntryIDs?: InputMaybe<ReadonlyArray<Scalars['ID']>>;
  readonly packing?: InputMaybe<Moving__PackingEnum>;
  readonly partnerUserToken?: InputMaybe<Scalars['ID']>;
  readonly phone: Scalars['String'];
  readonly promoCode?: InputMaybe<Scalars['String']>;
  readonly scheduled: Scalars['DateTime'];
  readonly slaWindow?: InputMaybe<Scalars['Duration']>;
  readonly token?: InputMaybe<Stripe__TokenInput>;
  readonly unitTypes?: InputMaybe<Scalars['UnitTypes']>;
  /** The unpacking date of the order. If a time component is provided, it will be discarded and replaced with the time component of the packing `scheduled` time. (e.g. for a EST to PST move, if there is a 7 AM EST packing time, there will be a 7 AM PST unpacking time) */
  readonly unpackingScheduled?: InputMaybe<Scalars['DateTime']>;
  readonly whiteGloveBundle?: InputMaybe<Scalars['String']>;
  readonly zip: Scalars['String'];
};

export type Moving__MoverCountOptionType = {
  readonly __typename?: 'Moving__MoverCountOptionType';
  readonly flatRateDetails?: Maybe<Moving__FlatRateDetails>;
  readonly laborRate?: Maybe<LaborRate>;
  readonly moverCount: Scalars['Int'];
  readonly recommended: Scalars['Boolean'];
  readonly truckCount: Scalars['Int'];
  readonly whiteGloveBundle?: Maybe<Moving__WhiteGloveBundleEnum>;
};

export enum Moving__MoveSizeEnum {
  Everything = 'EVERYTHING',
  Few = 'FEW',
  Half = 'HALF'
}

export type Moving__PackageSetEntry = {
  readonly __typename?: 'Moving__PackageSetEntry';
  readonly fixedCost: Scalars['Float'];
  readonly id: Scalars['ID'];
  readonly package: Package;
  readonly packageSet?: Maybe<PackageSet>;
  readonly signedID: Scalars['ID'];
};

export enum Moving__PackingEnum {
  AllItems = 'ALL_ITEMS',
  EverythingIsPacked = 'EVERYTHING_IS_PACKED',
  SomeItems = 'SOME_ITEMS'
}

export type Moving__PricingSummary = {
  readonly __typename?: 'Moving__PricingSummary';
  readonly fixedDuration?: Maybe<Scalars['Duration']>;
  readonly laborRate: LaborRate;
  readonly materialPackageSetEntry?: Maybe<Moving__PackageSetEntry>;
  readonly materialsAmount?: Maybe<Scalars['Float']>;
  readonly totalFixedAmount?: Maybe<Scalars['Float']>;
};

/** Autogenerated return type of Moving__QuoteCreate */
export type Moving__QuoteCreatePayload = {
  readonly __typename?: 'Moving__QuoteCreatePayload';
  readonly error?: Maybe<Scalars['String']>;
  readonly quote?: Maybe<Moving__QuoteType>;
  readonly status: Status;
};

export type Moving__QuoteInput = {
  readonly destinationAddress?: InputMaybe<Moving__AddressInput>;
  readonly materialPackageSetEntrySignedId?: InputMaybe<Scalars['ID']>;
  readonly moverOverride?: InputMaybe<Scalars['Int']>;
  readonly moveSize?: InputMaybe<Moving__MoveSizeEnum>;
  readonly originAddress?: InputMaybe<Moving__AddressInput>;
  readonly packing: Moving__PackingEnum;
  readonly packingSuppliesRequired?: InputMaybe<Scalars['Boolean']>;
  readonly partnerUserToken?: InputMaybe<Scalars['String']>;
  readonly requestedDate?: InputMaybe<Scalars['DateTime']>;
  readonly sizeClassification?: InputMaybe<Moving__SizeClassificationEnum>;
  readonly skippedAddressZip?: InputMaybe<Scalars['String']>;
  readonly unitTypes: Scalars['UnitTypes'];
  readonly visitorToken: Scalars['String'];
};

export type Moving__QuoteType = {
  readonly __typename?: 'Moving__QuoteType';
  readonly depositInterval: Scalars['Duration'];
  readonly destinationAttributes: Moving__Address;
  readonly driveDistanceInMiles?: Maybe<Scalars['Int']>;
  readonly eligibility: Scalars['Boolean'];
  readonly estimatedCuft: Scalars['Float'];
  readonly estimatedOrderCost?: Maybe<Scalars['Float']>;
  /** The lower bound of the estimated cargo weight. */
  readonly estimatedWeightLowerBound?: Maybe<Scalars['Int']>;
  /** The upper bound of the estimated cargo weight. */
  readonly estimatedWeightUpperBound?: Maybe<Scalars['Int']>;
  readonly flatRateOptions: ReadonlyArray<Moving__MoverCountOptionType>;
  readonly formattedDepositInterval: Scalars['String'];
  readonly fullServiceMoverCount?: Maybe<Scalars['Int']>;
  readonly id: Scalars['ID'];
  readonly laborRate?: Maybe<LaborRate>;
  readonly longDistanceTransportationRate?: Maybe<Moving__LongDistance__TransportationRate>;
  /** The transport fee, in dollars, for a long-distance move. If the move is not long-distance, this value will not be present. */
  readonly longDistanceTransportFee?: Maybe<Scalars['Int']>;
  readonly materialPackageSetEntry?: Maybe<Moving__PackageSetEntry>;
  /** The minimum weight in pounds to be billed for the cargo. */
  readonly minimumBilledWeight?: Maybe<Scalars['Int']>;
  readonly moverCountOptions: ReadonlyArray<Moving__MoverCountOptionType>;
  readonly moverSelection?: Maybe<Scalars['Int']>;
  readonly moveSize?: Maybe<Moving__MoveSizeEnum>;
  readonly movingConfiguration?: Maybe<MovingConfiguration>;
  readonly orderDurations?: Maybe<ReadonlyArray<Scalars['Float']>>;
  readonly originAttributes: Moving__Address;
  readonly packing: Moving__PackingEnum;
  readonly packingDays?: Maybe<Scalars['Int']>;
  readonly pricingSummary?: Maybe<Moving__PricingSummary>;
  readonly reasons?: Maybe<ReadonlyArray<Scalars['String']>>;
  readonly reservationDepositAmount?: Maybe<Scalars['Float']>;
  readonly selfMoveMoverCountOptions: ReadonlyArray<Moving__MoverCountOptionType>;
  readonly signedID: Scalars['ID'];
  readonly truckCount?: Maybe<Scalars['Int']>;
  readonly unitTypes: Scalars['UnitTypes'];
  readonly whiteGloveMoverCountOptions: ReadonlyArray<Moving__MoverCountOptionType>;
};

export type Moving__RouteSummary = {
  readonly __typename?: 'Moving__RouteSummary';
  readonly extendedDestinationServiceArea: Scalars['Boolean'];
  readonly extendedServiceArea: Scalars['Boolean'];
  readonly longDistance: Scalars['Boolean'];
  readonly validMoveRoute: Scalars['Boolean'];
};

export enum Moving__SizeClassificationEnum {
  OneBedroom = 'ONE_BEDROOM',
  Studio = 'STUDIO',
  TwoBedroomPlus = 'TWO_BEDROOM_PLUS'
}

export type Moving__StoragePlanInput = {
  readonly planID: Scalars['ID'];
  readonly pricing: DoorToDoor__OnboardingPricingInputType;
  readonly protectionPlanSlug?: InputMaybe<Scalars['String']>;
  readonly rateGroupID: Scalars['ID'];
  readonly subsource?: InputMaybe<Scalars['String']>;
};

export enum Moving__WhiteGloveBundleEnum {
  Basic = 'BASIC',
  FullService = 'FULL_SERVICE',
  PackingHelp = 'PACKING_HELP'
}

export type MovingConfiguration = {
  readonly __typename?: 'MovingConfiguration';
  readonly id: Scalars['ID'];
  readonly requiredLaborDuration: Scalars['Int'];
  readonly travelRateMultiplier: Scalars['Float'];
};

export type MovingMutationInterface = {
  readonly materialPackageSetEntriesFetch?: Maybe<Moving__MaterialPackageSetEntriesFetchPayload>;
  readonly moveCreate?: Maybe<Moving__MoveCreatePayload>;
  readonly movingQuoteCreate?: Maybe<Moving__QuoteCreatePayload>;
};


export type MovingMutationInterfaceMaterialPackageSetEntriesFetchArgs = {
  signedQuoteID: Scalars['ID'];
};


export type MovingMutationInterfaceMoveCreateArgs = {
  input: Moving__MoveInput;
  storagePlanInput?: InputMaybe<Moving__StoragePlanInput>;
};


export type MovingMutationInterfaceMovingQuoteCreateArgs = {
  input: Moving__QuoteInput;
};

export type MovingQueryInterface = {
  readonly movingRouteSummary: Moving__RouteSummary;
};


export type MovingQueryInterfaceMovingRouteSummaryArgs = {
  destinationAddress: AddressInput;
  moveSize?: InputMaybe<Moving__MoveSizeEnum>;
  originAddress: AddressInput;
  unitTypes?: InputMaybe<Scalars['UnitTypes']>;
};

export type MultidayAvailability = {
  readonly __typename?: 'MultidayAvailability';
  readonly available: Scalars['Boolean'];
  readonly datetime: Scalars['DateTime'];
  readonly duration?: Maybe<Scalars['Duration']>;
  readonly feeAmount?: Maybe<MonetaryAmount>;
  /** Formatted window (9:00 AM - 10:00 AM). */
  readonly formatted: Scalars['String'];
  readonly formattedFromTime: Scalars['String'];
  readonly fromTime: Scalars['DateTime'];
  /** Available return dates for multiday moves */
  readonly returnAvailabilities: ReadonlyArray<Scalars['Date']>;
  readonly tillTime: Scalars['DateTime'];
};

export type MultiExecuteInterface = {
  readonly abeetMultiExecute?: Maybe<MultiExecutePayload>;
};


export type MultiExecuteInterfaceAbeetMultiExecuteArgs = {
  familyNames: ReadonlyArray<Scalars['String']>;
  memberIdentifier: Scalars['String'];
  memberType: Scalars['String'];
};

/** Autogenerated return type of MultiExecute */
export type MultiExecutePayload = {
  readonly __typename?: 'MultiExecutePayload';
  readonly indexedVariables: Scalars['JSON'];
};

export type Mutation = DoorToDoorMutationInterface & MfaMutationInterface & MovingMutationInterface & MultiExecuteInterface & PricingMutationInterface & ReviewsMutationInterface & SelfStorageMutationInterface & {
  readonly __typename?: 'Mutation';
  readonly abeetMultiExecute?: Maybe<MultiExecutePayload>;
  readonly appointmentQuoteCreate?: Maybe<AppointmentQuoteCreatePayload>;
  readonly doorToDoorOnboardingReserve?: Maybe<DoorToDoor__Onboarding__CreatePayload>;
  readonly draftUpsert?: Maybe<DraftUpsertPayload>;
  readonly flowStepTransition?: Maybe<FlowStepTransitionPayload>;
  readonly leadCreate?: Maybe<LeadCreatePayload>;
  readonly materialPackageSetEntriesFetch?: Maybe<Moving__MaterialPackageSetEntriesFetchPayload>;
  readonly mfaAttemptMake?: Maybe<Mfa__MakeAttemptPayload>;
  readonly mfaRequestCreate?: Maybe<Mfa__RequestCreatePayload>;
  readonly moveCreate?: Maybe<Moving__MoveCreatePayload>;
  readonly movingQuoteCreate?: Maybe<Moving__QuoteCreatePayload>;
  readonly referralRedirectTrack?: Maybe<ReferralRedirectTrackPayload>;
  readonly reviewSave: ReviewSavePayload;
  readonly selfStorageRentalCreate: SelfStorage__Rental__CreatePayload;
  readonly selfStorageReservationCreate?: Maybe<SelfStorage__Reservation__CreatePayload>;
  readonly selfStorageShuttleBook?: Maybe<SelfStorage__ShuttleBookPayload>;
  readonly selfStorageSigningGenerate: SigningGeneratePayload;
  readonly selfStorageUnitSuggest?: Maybe<SelfStorage__Unit__SuggestPayload>;
  readonly zendeskCallbackRequestCreate?: Maybe<ZendeskCallbackRequestCreatePayload>;
};


export type MutationAbeetMultiExecuteArgs = {
  familyNames: ReadonlyArray<Scalars['String']>;
  memberIdentifier: Scalars['String'];
  memberType: Scalars['String'];
};


export type MutationAppointmentQuoteCreateArgs = {
  cuft: Scalars['Float'];
  quotableId: Scalars['ID'];
  quotableType: Pricing__QuotableEnum;
  rateGroupId: Scalars['ID'];
  source: Pricing__SourceEnum;
  zip: Scalars['String'];
};


export type MutationDoorToDoorOnboardingReserveArgs = {
  input: DoorToDoor__OnboardingInputType;
};


export type MutationDraftUpsertArgs = {
  input: DraftInput;
};


export type MutationFlowStepTransitionArgs = {
  input: FlowStepTransitionInput;
};


export type MutationLeadCreateArgs = {
  input: LeadInput;
  validateCustomerStatus?: InputMaybe<Scalars['Boolean']>;
};


export type MutationMaterialPackageSetEntriesFetchArgs = {
  signedQuoteID: Scalars['ID'];
};


export type MutationMfaAttemptMakeArgs = {
  input: Mfa__AttemptInput;
};


export type MutationMfaRequestCreateArgs = {
  input: Mfa__RequestInput;
};


export type MutationMoveCreateArgs = {
  input: Moving__MoveInput;
  storagePlanInput?: InputMaybe<Moving__StoragePlanInput>;
};


export type MutationMovingQuoteCreateArgs = {
  input: Moving__QuoteInput;
};


export type MutationReferralRedirectTrackArgs = {
  code: Scalars['String'];
  platform: Scalars['String'];
  source: Scalars['String'];
};


export type MutationReviewSaveArgs = {
  input: ReviewInput;
};


export type MutationSelfStorageRentalCreateArgs = {
  input: SelfStorage__RentalInput;
};


export type MutationSelfStorageReservationCreateArgs = {
  input: SelfStorage__Reservation__CreateInput;
};


export type MutationSelfStorageShuttleBookArgs = {
  input: SelfStorage__ShuttleInput;
};


export type MutationSelfStorageSigningGenerateArgs = {
  input: SelfStorage__RentalInput;
};


export type MutationSelfStorageUnitSuggestArgs = {
  reservationID: Scalars['ID'];
};


export type MutationZendeskCallbackRequestCreateArgs = {
  callbackAt: Scalars['DateTime'];
  contactPreference: CustomerTicket__ContactPreference;
  leadID: Scalars['ID'];
  tags?: InputMaybe<ReadonlyArray<Scalars['String']>>;
};

export type OnboardingCostSummary = {
  readonly __typename?: 'OnboardingCostSummary';
  readonly freeDuration?: Maybe<Scalars['Duration']>;
  readonly id: Scalars['ID'];
  readonly laborRate: LaborRate;
  readonly planId: Scalars['ID'];
  readonly rateGroupKind: RateGroupKindEnum;
};

export type OrderContact = {
  readonly __typename?: 'OrderContact';
  readonly id: Scalars['ID'];
  readonly name?: Maybe<Scalars['String']>;
  readonly phone: Scalars['String'];
};

export enum OrderServiceTypeEnum {
  Auction = 'AUCTION',
  /** @deprecated The capsule service is no longer offered. Do not remove from display components */
  Capsule = 'CAPSULE',
  CurbsidePickup = 'CURBSIDE_PICKUP',
  Disposal = 'DISPOSAL',
  /** @deprecated The doorstep service is no longer offered. Do not remove from display components */
  Doorstep = 'DOORSTEP',
  /** @deprecated The drop_off service is no longer offered. Do not remove from display components */
  DropOff = 'DROP_OFF',
  Facility = 'FACILITY',
  FullService = 'FULL_SERVICE',
  LongDistance = 'LONG_DISTANCE',
  Shipment = 'SHIPMENT',
  ThirdPartyReturn = 'THIRD_PARTY_RETURN'
}

export enum OrderStateEnum {
  Approved = 'APPROVED',
  Canceled = 'CANCELED',
  Completed = 'COMPLETED',
  Confirmed = 'CONFIRMED',
  Enroute = 'ENROUTE',
  Graded = 'GRADED',
  Packed = 'PACKED',
  Palletized = 'PALLETIZED',
  Pending = 'PENDING',
  Prepared = 'PREPARED',
  Returned = 'RETURNED',
  Unconfirmed = 'UNCONFIRMED'
}

export enum OrderSubtypeEnum {
  Cancelation = 'CANCELATION',
  Final = 'FINAL',
  None = 'NONE',
  Onboarding = 'ONBOARDING',
  Packing = 'PACKING',
  Subsequent = 'SUBSEQUENT',
  SupplyKit = 'SUPPLY_KIT',
  Travel = 'TRAVEL',
  Unpacking = 'UNPACKING'
}

export enum OrderTypeEnum {
  Disposal = 'DISPOSAL',
  Move = 'MOVE',
  Pickup = 'PICKUP',
  PickupReturn = 'PICKUP_RETURN',
  Restock = 'RESTOCK',
  RetailDelivery = 'RETAIL_DELIVERY',
  Return = 'RETURN',
  SelfStorageShuttle = 'SELF_STORAGE_SHUTTLE',
  TaskOrder = 'TASK_ORDER'
}

export type Package = {
  readonly __typename?: 'Package';
  readonly fullPack: Scalars['Boolean'];
  readonly id: Scalars['ID'];
  readonly kind: PackageKindEnum;
  readonly name: Scalars['String'];
};

export enum PackageKindEnum {
  Core = 'CORE',
  DisposalDonation = 'DISPOSAL_DONATION',
  EarlyReturn = 'EARLY_RETURN',
  ExtendedServiceArea = 'EXTENDED_SERVICE_AREA',
  FinalReturn = 'FINAL_RETURN',
  FlatRateService = 'FLAT_RATE_SERVICE',
  FlexibleScheduling = 'FLEXIBLE_SCHEDULING',
  GasFee = 'GAS_FEE',
  LongDistanceTransport = 'LONG_DISTANCE_TRANSPORT',
  LongTerm = 'LONG_TERM',
  OnboardingService = 'ONBOARDING_SERVICE',
  OrderFee = 'ORDER_FEE',
  PackingSupplies = 'PACKING_SUPPLIES',
  Plus = 'PLUS',
  PreferredSchedulingFee = 'PREFERRED_SCHEDULING_FEE',
  SmallAppointment = 'SMALL_APPOINTMENT',
  TimeSlotSelectionFee = 'TIME_SLOT_SELECTION_FEE',
  TruckAndDriver = 'TRUCK_AND_DRIVER',
  WarehouseService = 'WAREHOUSE_SERVICE'
}

export type PackageSet = {
  readonly __typename?: 'PackageSet';
  readonly id: Scalars['ID'];
  readonly name: Scalars['String'];
};

export type PackageSetEntry = {
  readonly __typename?: 'PackageSetEntry';
  readonly amount?: Maybe<Scalars['Int']>;
  readonly cappedAtOnboardingAmount: Scalars['Boolean'];
  readonly costPerCuft: Scalars['Float'];
  readonly fixedCost: Scalars['Float'];
  readonly id: Scalars['ID'];
  readonly minimumTermMonths: Scalars['Int'];
  readonly orderSubtype: Scalars['String'];
  readonly package: Package;
  readonly packageSet?: Maybe<PackageSet>;
  readonly storageCostMultiplier: Scalars['Float'];
};


export type PackageSetEntryAmountArgs = {
  cuft: Scalars['Float'];
  storagePrice?: InputMaybe<Scalars['Float']>;
};

export type PackageSetEntryInput = {
  readonly amount: Scalars['Int'];
  readonly id: Scalars['ID'];
};

export type Plan = {
  readonly __typename?: 'Plan';
  readonly cuft: Scalars['Int'];
  readonly id: Scalars['ID'];
  readonly kind: PlanKindEnum;
  readonly name: Scalars['String'];
  readonly type: PlanTypeEnum;
};

export enum PlanKindEnum {
  Custom = 'CUSTOM',
  Fixed = 'FIXED',
  Item = 'ITEM'
}

export enum PlanTypeEnum {
  ProtectionPlan = 'PROTECTION_PLAN',
  StoragePlan = 'STORAGE_PLAN'
}

export type Polygon = {
  readonly __typename?: 'Polygon';
  readonly paths: ReadonlyArray<ReadonlyArray<LocatablePoint>>;
};

export type Pricing = {
  readonly __typename?: 'Pricing';
  readonly amount: Scalars['Float'];
  readonly currency: Currency;
  readonly id: Scalars['ID'];
  readonly plan: Plan;
};

export type Pricing__Bundle = {
  readonly __typename?: 'Pricing__Bundle';
  readonly id: Scalars['ID'];
  readonly kind: DoorToDoor__BundleEnum;
  readonly name: Scalars['String'];
  readonly packageSetEntry?: Maybe<PackageSetEntry>;
};

export enum Pricing__QuotableEnum {
  Customer = 'CUSTOMER',
  Visitor = 'VISITOR'
}

export enum Pricing__SourceEnum {
  Landing = 'LANDING',
  LandingReonboarding = 'LANDING_REONBOARDING'
}

export type PricingGroupLaborEntry = {
  readonly __typename?: 'PricingGroupLaborEntry';
  readonly id: Scalars['ID'];
  readonly laborPolicy: LaborPolicy;
  readonly rateGroup?: Maybe<RateGroup>;
  readonly storageTerm: StorageTerm;
};

export type PricingGroupPricingEntry = {
  readonly __typename?: 'PricingGroupPricingEntry';
  readonly id: Scalars['ID'];
  readonly pricing: Pricing;
  readonly rateGroup?: Maybe<RateGroup>;
};

export type PricingInterface = {
  readonly pricingBundles: ReadonlyArray<Pricing__Bundle>;
  readonly pricingFinalReturnCostSummaries: ReadonlyArray<FinalReturnCostSummary>;
  readonly pricingOnboardingCostSummaries: ReadonlyArray<OnboardingCostSummary>;
};


export type PricingInterfacePricingBundlesArgs = {
  cuft?: InputMaybe<Scalars['Int']>;
};


export type PricingInterfacePricingFinalReturnCostSummariesArgs = {
  planIds: ReadonlyArray<Scalars['ID']>;
  pricingSetId: Scalars['ID'];
  rateGroupKinds: ReadonlyArray<RateGroupKindEnum>;
};


export type PricingInterfacePricingOnboardingCostSummariesArgs = {
  planIds: ReadonlyArray<Scalars['ID']>;
  pricingSetId: Scalars['ID'];
  rateGroupKinds: ReadonlyArray<RateGroupKindEnum>;
};

export type PricingMutationInterface = {
  readonly appointmentQuoteCreate?: Maybe<AppointmentQuoteCreatePayload>;
};


export type PricingMutationInterfaceAppointmentQuoteCreateArgs = {
  cuft: Scalars['Float'];
  quotableId: Scalars['ID'];
  quotableType: Pricing__QuotableEnum;
  rateGroupId: Scalars['ID'];
  source: Pricing__SourceEnum;
  zip: Scalars['String'];
};

export type PricingSet = {
  readonly __typename?: 'PricingSet';
  readonly id: Scalars['ID'];
  readonly laborPricingGroupEntries: ReadonlyArray<PricingGroupLaborEntry>;
  readonly marketPricingVariantLabel?: Maybe<Scalars['String']>;
  readonly protectionPricingGroupEntries: ReadonlyArray<PricingGroupPricingEntry>;
  readonly quoteId?: Maybe<Scalars['ID']>;
  readonly storagePricingGroupEntries: ReadonlyArray<PricingGroupPricingEntry>;
};

export type QualifiedContact__Link = {
  readonly __typename?: 'QualifiedContact__Link';
  readonly id: Scalars['ID'];
  readonly text: Scalars['String'];
  readonly url: Scalars['String'];
};

export type QualifiedContact__Topic = {
  readonly __typename?: 'QualifiedContact__Topic';
  readonly content: Scalars['String'];
  readonly id: Scalars['ID'];
  readonly links: ReadonlyArray<QualifiedContact__Link>;
  readonly section: QualifiedContact__Topic__Section;
  readonly subjects?: Maybe<ReadonlyArray<QualifiedContact__Topic__Subject>>;
  readonly title: Scalars['String'];
};

export enum QualifiedContact__Topic__Section {
  Customer = 'CUSTOMER',
  Visitor = 'VISITOR'
}

export enum QualifiedContact__Topic__Subject {
  DropOff = 'DROP_OFF'
}

export type Query = CalculatePackageSetEntryAmountInterface & EstimationQueryInterface & LocationsQueryInterface & MovingQueryInterface & PricingInterface & SelfStorageQueryInterface & SelfStorageThirdPartyQueryInterface & {
  readonly __typename?: 'Query';
  readonly allowImmediateCallback: Scalars['Boolean'];
  readonly availabilities: ReadonlyArray<Availability>;
  readonly calculatePackageSetEntryAmount?: Maybe<Scalars['Int']>;
  readonly callbackWindows: ReadonlyArray<CallbackWindow>;
  readonly cheapestSelfStorageUnitPrice?: Maybe<SelfStorage__Price>;
  readonly cheapestSelfStorageUnitPriceForFacilities?: Maybe<SelfStorage__Price>;
  readonly commonItemCategories: ReadonlyArray<Estimation__ItemCategory>;
  readonly coupon: CouponOrError;
  readonly disposalCategoryPricing: ReadonlyArray<Disposal__CategoryPricingDescriptor>;
  readonly draft?: Maybe<Draft>;
  readonly estimatedMovers: Scalars['Int'];
  readonly geocode?: Maybe<Geocode>;
  readonly isExistingCustomer: Scalars['Boolean'];
  readonly itemCategorySearch: ReadonlyArray<Estimation__ItemCategory>;
  readonly lead: Lead;
  readonly longDistanceAvailabilities: ReadonlyArray<MultidayAvailability>;
  readonly movingRouteSummary: Moving__RouteSummary;
  readonly popularSelfStorageUnitGroups: ReadonlyArray<SelfStorage__UnitGroup>;
  readonly pricingBundles: ReadonlyArray<Pricing__Bundle>;
  readonly pricingFinalReturnCostSummaries: ReadonlyArray<FinalReturnCostSummary>;
  readonly pricingOnboardingCostSummaries: ReadonlyArray<OnboardingCostSummary>;
  readonly pricingSet?: Maybe<PricingSet>;
  readonly qualifiedContactTopics: ReadonlyArray<QualifiedContact__Topic>;
  readonly referral?: Maybe<ReferralPromo>;
  readonly regions: ReadonlyArray<Region>;
  readonly reonboardingCustomer?: Maybe<Customer>;
  readonly reservableSelfStorageUnitGroups: ReadonlyArray<SelfStorage__UnitGroup>;
  readonly route?: Maybe<Landing__Location__Route>;
  readonly routes: ReadonlyArray<Landing__Location__Route>;
  /** Determine sales tax rate by zip code */
  readonly salesTax: TaxRate;
  readonly savingsAgainstTruckRental?: Maybe<Scalars['Int']>;
  readonly selfStorageReservation?: Maybe<SelfStorage__Reservation>;
  readonly selfStorageUnitGroupsByBounds: ReadonlyArray<SelfStorage__UnitGroup>;
  readonly signedSelfStorageReservation?: Maybe<SelfStorage__Reservation>;
  readonly state?: Maybe<Location__State>;
  readonly states: ReadonlyArray<Location__State>;
  readonly thirdPartyFacilitiesWithinBounds: ReadonlyArray<SelfStorage__Facility>;
  readonly zipsWithMoving: ReadonlyArray<Scalars['String']>;
  readonly zipsWithSelfStorage: ReadonlyArray<Scalars['String']>;
};


export type QueryAllowImmediateCallbackArgs = {
  department?: InputMaybe<CallbackDepartment>;
};


export type QueryAvailabilitiesArgs = {
  input: AvailabilitiesInput;
};


export type QueryCalculatePackageSetEntryAmountArgs = {
  cuft: Scalars['Float'];
  packageKind: Scalars['String'];
  packageSetName: Scalars['String'];
};


export type QueryCallbackWindowsArgs = {
  department?: InputMaybe<CallbackDepartment>;
};


export type QueryCheapestSelfStorageUnitPriceArgs = {
  zip: Scalars['String'];
};


export type QueryCheapestSelfStorageUnitPriceForFacilitiesArgs = {
  facilityIDs: ReadonlyArray<Scalars['ID']>;
};


export type QueryCouponArgs = {
  code: Scalars['String'];
  service?: InputMaybe<Scalars['String']>;
};


export type QueryEstimatedMoversArgs = {
  planId: Scalars['ID'];
  postalCode?: InputMaybe<Scalars['String']>;
  serviceType?: InputMaybe<OrderServiceTypeEnum>;
};


export type QueryGeocodeArgs = {
  zip: Scalars['String'];
};


export type QueryIsExistingCustomerArgs = {
  email?: InputMaybe<Scalars['String']>;
  phoneNumber?: InputMaybe<Scalars['String']>;
};


export type QueryItemCategorySearchArgs = {
  query: Scalars['String'];
};


export type QueryLeadArgs = {
  token: Scalars['ID'];
};


export type QueryLongDistanceAvailabilitiesArgs = {
  input: AvailabilitiesInput;
};


export type QueryMovingRouteSummaryArgs = {
  destinationAddress: AddressInput;
  moveSize?: InputMaybe<Moving__MoveSizeEnum>;
  originAddress: AddressInput;
  unitTypes?: InputMaybe<Scalars['UnitTypes']>;
};


export type QueryPopularSelfStorageUnitGroupsArgs = {
  facilityIDs: ReadonlyArray<Scalars['ID']>;
};


export type QueryPricingBundlesArgs = {
  cuft?: InputMaybe<Scalars['Int']>;
};


export type QueryPricingFinalReturnCostSummariesArgs = {
  planIds: ReadonlyArray<Scalars['ID']>;
  pricingSetId: Scalars['ID'];
  rateGroupKinds: ReadonlyArray<RateGroupKindEnum>;
};


export type QueryPricingOnboardingCostSummariesArgs = {
  planIds: ReadonlyArray<Scalars['ID']>;
  pricingSetId: Scalars['ID'];
  rateGroupKinds: ReadonlyArray<RateGroupKindEnum>;
};


export type QueryPricingSetArgs = {
  source?: InputMaybe<Scalars['String']>;
  visitorToken: Scalars['String'];
  zip: Scalars['String'];
};


export type QueryReferralArgs = {
  promoCode: Scalars['String'];
};


export type QueryReonboardingCustomerArgs = {
  token: Scalars['String'];
};


export type QueryReservableSelfStorageUnitGroupsArgs = {
  facilityID: Scalars['ID'];
};


export type QueryRouteArgs = {
  slug: Scalars['ID'];
};


export type QueryRoutesArgs = {
  featured?: InputMaybe<Scalars['Boolean']>;
};


export type QuerySalesTaxArgs = {
  zipCode: Scalars['String'];
};


export type QuerySavingsAgainstTruckRentalArgs = {
  sqft: Scalars['Int'];
  zip: Scalars['String'];
};


export type QuerySelfStorageReservationArgs = {
  email: Scalars['String'];
  token: Scalars['String'];
};


export type QuerySelfStorageUnitGroupsByBoundsArgs = {
  bounds: LocatableBoundsInput;
  filters?: InputMaybe<SelfStorage__UnitGroupFiltersInput>;
  limit?: InputMaybe<Scalars['Int']>;
  thirdParty?: InputMaybe<Scalars['Boolean']>;
};


export type QuerySignedSelfStorageReservationArgs = {
  signedID: Scalars['ID'];
};


export type QueryStateArgs = {
  slug: Scalars['ID'];
};


export type QueryThirdPartyFacilitiesWithinBoundsArgs = {
  input: LocatableBoundsInput;
  limit?: InputMaybe<Scalars['Int']>;
};

export type RateGroup = {
  readonly __typename?: 'RateGroup';
  readonly curbside: Scalars['Boolean'];
  readonly id: Scalars['ID'];
  readonly name: RateGroupKindEnum;
};

export enum RateGroupKindEnum {
  /** @deprecated The Capsule Mover rate group is no longer offered */
  CapsuleMover = 'CAPSULE_MOVER',
  CurbsideFlexer = 'CURBSIDE_FLEXER',
  CurbsideMover = 'CURBSIDE_MOVER',
  CurbsideSaver = 'CURBSIDE_SAVER',
  /** @deprecated The Drop-off Flexer rate group is no longer offered */
  DropOffFlexer = 'DROP_OFF_FLEXER',
  /** @deprecated The Drop-off Mover rate group is no longer offered */
  DropOffMover = 'DROP_OFF_MOVER',
  /** @deprecated The Drop-off Saver rate group is no longer offered */
  DropOffSaver = 'DROP_OFF_SAVER',
  Flexer = 'FLEXER',
  LongTerm = 'LONG_TERM',
  Mover = 'MOVER',
  Saver = 'SAVER',
  ShortTerm = 'SHORT_TERM'
}

export enum Rating {
  Good = 'GOOD',
  Poor = 'POOR'
}

export type ReferralPromo = {
  readonly __typename?: 'ReferralPromo';
  readonly code: Scalars['String'];
  readonly coupons: ReadonlyArray<Coupon>;
  readonly name: Scalars['String'];
};

/** Autogenerated return type of ReferralRedirectTrack */
export type ReferralRedirectTrackPayload = {
  readonly __typename?: 'ReferralRedirectTrackPayload';
  readonly url: Scalars['String'];
};

export type Region = {
  readonly __typename?: 'Region';
  readonly id: Scalars['ID'];
  readonly name: Scalars['String'];
  readonly tz: Scalars['String'];
  readonly zipCodes: ReadonlyArray<Scalars['String']>;
};

export type ReviewInput = {
  readonly comments?: InputMaybe<Scalars['String']>;
  readonly rating: Rating;
  readonly reasons: Scalars['Hash'];
  readonly url: Scalars['String'];
};

/** Autogenerated return type of ReviewSave */
export type ReviewSavePayload = {
  readonly __typename?: 'ReviewSavePayload';
  readonly status: Status;
};

export type ReviewsMutationInterface = {
  readonly reviewSave: ReviewSavePayload;
};


export type ReviewsMutationInterfaceReviewSaveArgs = {
  input: ReviewInput;
};

export type RouteLocation = Location__City | Location__Neighborhood | Location__State;

export type SelfStorage__AddressesInput = {
  readonly billing?: InputMaybe<AddressInput>;
  readonly mailing?: InputMaybe<AddressInput>;
};

export type SelfStorage__Classification = {
  readonly __typename?: 'SelfStorage__Classification';
  readonly amenities: ReadonlyArray<Scalars['String']>;
  readonly category: SelfStorage__Classification__Category;
  readonly climate: Scalars['Boolean'];
  readonly electricity: Scalars['Boolean'];
  readonly firstFloor: Scalars['Boolean'];
  readonly height: Scalars['Float'];
  readonly id: Scalars['ID'];
  readonly indoors: Scalars['Boolean'];
  readonly kind: SelfStorage__Kind;
  readonly length: Scalars['Float'];
  readonly obstructed: Scalars['Boolean'];
  readonly width: Scalars['Float'];
};

export enum SelfStorage__Classification__Category {
  Locker = 'LOCKER',
  ParkingMotorcycle = 'PARKING_MOTORCYCLE',
  ParkingVehicle = 'PARKING_VEHICLE',
  Unit = 'UNIT'
}

export type SelfStorage__CustomerInput = {
  readonly email: Scalars['Email'];
  readonly name: Scalars['String'];
  readonly phone: Scalars['String'];
};

export type SelfStorage__Document = {
  readonly __typename?: 'SelfStorage__Document';
  readonly id: Scalars['ID'];
  readonly name: Scalars['String'];
};

export type SelfStorage__Facility = {
  readonly __typename?: 'SelfStorage__Facility';
  readonly address: Address;
  readonly fees: ReadonlyArray<SelfStorage__Fee>;
  readonly id: Scalars['ID'];
  readonly name: Scalars['String'];
  readonly partner: SelfStorage__Partner;
  readonly phone: Scalars['String'];
  readonly protections: ReadonlyArray<SelfStorage__Protection>;
};

export type SelfStorage__Fee = {
  readonly __typename?: 'SelfStorage__Fee';
  readonly id: Scalars['ID'];
  readonly kind: SelfStorage__Fee__Kind;
  readonly price: Scalars['Float'];
  readonly recurring: Scalars['Boolean'];
};

export enum SelfStorage__Fee__Kind {
  Admin = 'ADMIN',
  Convenience = 'CONVENIENCE',
  Electricity = 'ELECTRICITY',
  ExtendedAccess = 'EXTENDED_ACCESS',
  Lock = 'LOCK',
  UnlimitedAccess = 'UNLIMITED_ACCESS'
}

export type SelfStorage__Kind = {
  readonly __typename?: 'SelfStorage__Kind';
  readonly formattedName: Scalars['String'];
  readonly id: Scalars['ID'];
  readonly name: Scalars['String'];
  readonly subtype?: Maybe<SelfStorage__Kind__Subtype>;
};

export enum SelfStorage__Kind__Subtype {
  Motorcycle = 'MOTORCYCLE',
  Vehicle = 'VEHICLE'
}

export type SelfStorage__Partner = {
  readonly __typename?: 'SelfStorage__Partner';
  readonly company: SelfStorage__Partner__Company;
  readonly id: Scalars['ID'];
  readonly isThirdParty: Scalars['Boolean'];
  readonly name: Scalars['String'];
};

export enum SelfStorage__Partner__Company {
  Clutter = 'CLUTTER',
  DevonSelfStorage = 'DEVON_SELF_STORAGE',
  ExtraSpace = 'EXTRA_SPACE',
  PublicStorage = 'PUBLIC_STORAGE'
}

export enum SelfStorage__Policy__Kind {
  AutoInsurance = 'AUTO_INSURANCE',
  Commercial = 'COMMERCIAL',
  GeneralLiability = 'GENERAL_LIABILITY',
  Homeowner = 'HOMEOWNER',
  Renter = 'RENTER',
  UmbrellaCoverage = 'UMBRELLA_COVERAGE'
}

export type SelfStorage__PolicyInput = {
  readonly amount: Scalars['Float'];
  readonly company: Scalars['String'];
  readonly from: Scalars['Date'];
  readonly kind: SelfStorage__Policy__Kind;
  readonly number: Scalars['String'];
  readonly till: Scalars['Date'];
};

export type SelfStorage__Price = {
  readonly __typename?: 'SelfStorage__Price';
  readonly id: Scalars['ID'];
  readonly pushRate: Scalars['Float'];
  readonly quotedRate: Scalars['Float'];
  readonly rate: Scalars['Float'];
};

export type SelfStorage__Promotion = {
  readonly __typename?: 'SelfStorage__Promotion';
  /** The number of months until the promotion is applied. */
  readonly delay: Scalars['Int'];
  readonly id: Scalars['ID'];
  readonly kind: SelfStorage__Promotion__Kind;
  /** A summary of the promotion (i.e. "$30/month for 2 months"). */
  readonly name: Scalars['String'];
  /** The number of months the promotion discounts a subscription for. */
  readonly term: Scalars['Int'];
  /** The percent or amount applied (i.e. 20% or $30) to the promotion. */
  readonly value: Scalars['Float'];
};

export enum SelfStorage__Promotion__Kind {
  Amount = 'AMOUNT',
  Override = 'OVERRIDE',
  Percent = 'PERCENT'
}

export type SelfStorage__Protection = {
  readonly __typename?: 'SelfStorage__Protection';
  readonly amount: Scalars['Float'];
  readonly id: Scalars['ID'];
  readonly name: Scalars['String'];
  readonly price: Scalars['Float'];
  readonly rank: SelfStorage__Protection__Rank;
};

export enum SelfStorage__Protection__Rank {
  Basic = 'BASIC',
  Premium = 'PREMIUM',
  Standard = 'STANDARD'
}

/** Autogenerated return type of SelfStorage__Rental__Create */
export type SelfStorage__Rental__CreatePayload = {
  readonly __typename?: 'SelfStorage__Rental__CreatePayload';
  readonly error?: Maybe<Scalars['String']>;
  readonly status: Status;
};

export type SelfStorage__RentalAttributesInput = {
  readonly policy?: InputMaybe<SelfStorage__PolicyInput>;
  readonly signatureIDs?: InputMaybe<ReadonlyArray<Scalars['ID']>>;
};

export type SelfStorage__RentalInput = {
  readonly addresses: SelfStorage__AddressesInput;
  readonly customer: SelfStorage__CustomerInput;
  readonly feeIDs: ReadonlyArray<Scalars['ID']>;
  readonly military?: InputMaybe<Scalars['Boolean']>;
  readonly protectionID?: InputMaybe<Scalars['ID']>;
  readonly rental: SelfStorage__RentalAttributesInput;
  readonly reservationID: Scalars['ID'];
  readonly token: Stripe__TokenInput;
  readonly unitID: Scalars['ID'];
};

export type SelfStorage__Reservation = {
  readonly __typename?: 'SelfStorage__Reservation';
  readonly classification?: Maybe<SelfStorage__Classification>;
  readonly createdAt: Scalars['DateTime'];
  readonly date?: Maybe<Scalars['Date']>;
  readonly email: Scalars['String'];
  readonly facility: SelfStorage__Facility;
  readonly id: Scalars['ID'];
  readonly lead: Lead;
  readonly length?: Maybe<Scalars['Float']>;
  readonly name: Scalars['String'];
  readonly order?: Maybe<SelfStorage__Shuttle>;
  readonly phone: Scalars['String'];
  readonly price?: Maybe<SelfStorage__Price>;
  readonly promotion?: Maybe<SelfStorage__Promotion>;
  readonly quotedPrice?: Maybe<Scalars['Float']>;
  readonly signedID: Scalars['ID'];
  readonly state: SelfStorage__Reservation__State;
  readonly token: Scalars['String'];
  readonly unitType?: Maybe<Scalars['String']>;
  readonly updatedAt: Scalars['DateTime'];
  readonly user: User;
  readonly width?: Maybe<Scalars['Float']>;
  readonly zip?: Maybe<Scalars['String']>;
};

export type SelfStorage__Reservation__CreateInput = {
  readonly classificationID: Scalars['ID'];
  readonly confirmationNumber?: InputMaybe<Scalars['String']>;
  readonly date: Scalars['Date'];
  readonly email?: InputMaybe<Scalars['Email']>;
  readonly facilityID: Scalars['ID'];
  readonly firstName?: InputMaybe<Scalars['String']>;
  readonly lastName?: InputMaybe<Scalars['String']>;
  readonly leadID?: InputMaybe<Scalars['ID']>;
  readonly leadToken?: InputMaybe<Scalars['String']>;
  readonly marketingData?: InputMaybe<MarketingDataInput>;
  readonly phone?: InputMaybe<Scalars['String']>;
  readonly priceID: Scalars['ID'];
  readonly promotionID?: InputMaybe<Scalars['ID']>;
  readonly smsSubscribed?: InputMaybe<Scalars['Boolean']>;
  readonly zip?: InputMaybe<Scalars['String']>;
};

/** Autogenerated return type of SelfStorage__Reservation__Create */
export type SelfStorage__Reservation__CreatePayload = {
  readonly __typename?: 'SelfStorage__Reservation__CreatePayload';
  readonly error?: Maybe<Error>;
  readonly reservation?: Maybe<SelfStorage__Reservation>;
  readonly status: Status;
};

export enum SelfStorage__Reservation__State {
  Canceled = 'CANCELED',
  Lost = 'LOST',
  Pending = 'PENDING',
  Requested = 'REQUESTED',
  Won = 'WON'
}

export type SelfStorage__Shuttle = {
  readonly __typename?: 'SelfStorage__Shuttle';
  readonly account: Account;
  readonly address: Address;
  readonly contact?: Maybe<OrderContact>;
  readonly createdAt: Scalars['DateTime'];
  /** Formatted SLA window (9:00 AM - 10:00 AM). */
  readonly formattedWindow: Scalars['String'];
  readonly id: Scalars['ID'];
  readonly reservation: SelfStorage__Reservation;
  readonly scheduled: Scalars['DateTime'];
  readonly state: OrderStateEnum;
  readonly updatedAt: Scalars['DateTime'];
  readonly window: Scalars['Duration'];
};

/** Autogenerated return type of SelfStorage__ShuttleBook */
export type SelfStorage__ShuttleBookPayload = {
  readonly __typename?: 'SelfStorage__ShuttleBookPayload';
  readonly error?: Maybe<Scalars['String']>;
  readonly shuttle?: Maybe<SelfStorage__Shuttle>;
  readonly status: Status;
};

export type SelfStorage__ShuttleInput = {
  readonly address: AddressInput;
  readonly duration?: InputMaybe<Scalars['Duration']>;
  readonly email: Scalars['Email'];
  readonly name: Scalars['String'];
  readonly phone: Scalars['String'];
  readonly reservationToken: Scalars['String'];
  readonly scheduled: Scalars['DateTime'];
  readonly subsource?: InputMaybe<Scalars['String']>;
  readonly userToken?: InputMaybe<Scalars['String']>;
};

export type SelfStorage__Signature = {
  readonly __typename?: 'SelfStorage__Signature';
  readonly document: SelfStorage__Document;
  readonly id: Scalars['ID'];
  readonly signedID: Scalars['ID'];
};

export type SelfStorage__Unit = {
  readonly __typename?: 'SelfStorage__Unit';
  readonly classification: SelfStorage__Classification;
  readonly id: Scalars['ID'];
  readonly name: Scalars['String'];
};

/** Autogenerated return type of SelfStorage__Unit__Suggest */
export type SelfStorage__Unit__SuggestPayload = {
  readonly __typename?: 'SelfStorage__Unit__SuggestPayload';
  readonly error?: Maybe<Scalars['String']>;
  readonly status: Status;
  readonly unit?: Maybe<SelfStorage__Unit>;
};

export type SelfStorage__UnitGroup = {
  readonly __typename?: 'SelfStorage__UnitGroup';
  readonly bookingWindow?: Maybe<Scalars['Duration']>;
  readonly classification: SelfStorage__Classification;
  readonly facility: SelfStorage__Facility;
  readonly id: Scalars['ID'];
  readonly price: SelfStorage__Price;
  readonly promotion?: Maybe<SelfStorage__Promotion>;
  readonly remaining: Scalars['Int'];
};

export type SelfStorage__UnitGroupFiltersInput = {
  readonly maxPrice?: InputMaybe<Scalars['Int']>;
  readonly unitSizes?: InputMaybe<ReadonlyArray<SelfStorage__UnitSize>>;
};

export enum SelfStorage__UnitSize {
  Size_10x10 = 'SIZE_10x10',
  Size_10x15 = 'SIZE_10x15',
  Size_5x10 = 'SIZE_5x10',
  Size_5x5 = 'SIZE_5x5',
  SizeVehicle = 'SIZE_VEHICLE'
}

export type SelfStorageMutationInterface = {
  readonly selfStorageRentalCreate: SelfStorage__Rental__CreatePayload;
  readonly selfStorageReservationCreate?: Maybe<SelfStorage__Reservation__CreatePayload>;
  readonly selfStorageShuttleBook?: Maybe<SelfStorage__ShuttleBookPayload>;
  readonly selfStorageSigningGenerate: SigningGeneratePayload;
  readonly selfStorageUnitSuggest?: Maybe<SelfStorage__Unit__SuggestPayload>;
};


export type SelfStorageMutationInterfaceSelfStorageRentalCreateArgs = {
  input: SelfStorage__RentalInput;
};


export type SelfStorageMutationInterfaceSelfStorageReservationCreateArgs = {
  input: SelfStorage__Reservation__CreateInput;
};


export type SelfStorageMutationInterfaceSelfStorageShuttleBookArgs = {
  input: SelfStorage__ShuttleInput;
};


export type SelfStorageMutationInterfaceSelfStorageSigningGenerateArgs = {
  input: SelfStorage__RentalInput;
};


export type SelfStorageMutationInterfaceSelfStorageUnitSuggestArgs = {
  reservationID: Scalars['ID'];
};

export type SelfStorageQueryInterface = {
  readonly cheapestSelfStorageUnitPrice?: Maybe<SelfStorage__Price>;
  readonly cheapestSelfStorageUnitPriceForFacilities?: Maybe<SelfStorage__Price>;
  readonly popularSelfStorageUnitGroups: ReadonlyArray<SelfStorage__UnitGroup>;
  readonly reservableSelfStorageUnitGroups: ReadonlyArray<SelfStorage__UnitGroup>;
  readonly selfStorageReservation?: Maybe<SelfStorage__Reservation>;
  readonly selfStorageUnitGroupsByBounds: ReadonlyArray<SelfStorage__UnitGroup>;
  readonly signedSelfStorageReservation?: Maybe<SelfStorage__Reservation>;
};


export type SelfStorageQueryInterfaceCheapestSelfStorageUnitPriceArgs = {
  zip: Scalars['String'];
};


export type SelfStorageQueryInterfaceCheapestSelfStorageUnitPriceForFacilitiesArgs = {
  facilityIDs: ReadonlyArray<Scalars['ID']>;
};


export type SelfStorageQueryInterfacePopularSelfStorageUnitGroupsArgs = {
  facilityIDs: ReadonlyArray<Scalars['ID']>;
};


export type SelfStorageQueryInterfaceReservableSelfStorageUnitGroupsArgs = {
  facilityID: Scalars['ID'];
};


export type SelfStorageQueryInterfaceSelfStorageReservationArgs = {
  email: Scalars['String'];
  token: Scalars['String'];
};


export type SelfStorageQueryInterfaceSelfStorageUnitGroupsByBoundsArgs = {
  bounds: LocatableBoundsInput;
  filters?: InputMaybe<SelfStorage__UnitGroupFiltersInput>;
  limit?: InputMaybe<Scalars['Int']>;
  thirdParty?: InputMaybe<Scalars['Boolean']>;
};


export type SelfStorageQueryInterfaceSignedSelfStorageReservationArgs = {
  signedID: Scalars['ID'];
};

export type SelfStorageThirdPartyQueryInterface = {
  readonly thirdPartyFacilitiesWithinBounds: ReadonlyArray<SelfStorage__Facility>;
};


export type SelfStorageThirdPartyQueryInterfaceThirdPartyFacilitiesWithinBoundsArgs = {
  input: LocatableBoundsInput;
  limit?: InputMaybe<Scalars['Int']>;
};

/** Autogenerated return type of SigningGenerate */
export type SigningGeneratePayload = {
  readonly __typename?: 'SigningGeneratePayload';
  readonly signatures: ReadonlyArray<SelfStorage__Signature>;
  readonly url: Scalars['String'];
};

export type Source = {
  readonly __typename?: 'Source';
  readonly fundingType?: Maybe<Scalars['String']>;
  readonly number?: Maybe<Scalars['String']>;
};

export enum Status {
  Ok = 'OK',
  Unauthorized = 'UNAUTHORIZED',
  Unprocessable = 'UNPROCESSABLE'
}

export type StorageTerm = {
  readonly __typename?: 'StorageTerm';
  readonly id: Scalars['ID'];
  readonly minimumMonths: Scalars['Int'];
  readonly name: Scalars['String'];
  readonly rateGroup: RateGroup;
};

export type Stripe__TokenInput = {
  /** A unique identifier that can be parsed into a source. */
  readonly id: Scalars['ID'];
};

export type TaxRate = {
  readonly __typename?: 'TaxRate';
  readonly percent: Scalars['Float'];
};

export type User = {
  readonly __typename?: 'User';
  readonly email: Scalars['String'];
  readonly id: Scalars['ID'];
  readonly name: Scalars['String'];
};

/** Autogenerated return type of ZendeskCallbackRequestCreate */
export type ZendeskCallbackRequestCreatePayload = {
  readonly __typename?: 'ZendeskCallbackRequestCreatePayload';
  readonly error?: Maybe<Error>;
  readonly status: Status;
};

export type ItemCategorySearchQueryVariables = Exact<{
  query: Scalars['String'];
}>;


export type ItemCategorySearchQuery = { readonly __typename?: 'Query', readonly results: ReadonlyArray<{ readonly __typename?: 'Estimation__ItemCategory', readonly id: string, readonly name: string, readonly cuft: number }> };

export type AddressFragment = { readonly __typename?: 'Address', readonly id: string, readonly street: string, readonly aptsuite?: string | null, readonly city: string, readonly state: string, readonly zip: string, readonly latitude?: number | null, readonly longitude?: number | null };

export type AvailabilityFragment = { readonly __typename?: 'Availability', readonly available: boolean, readonly fromTime: string, readonly tillTime: string, readonly formatted: string, readonly duration?: string | null, readonly formattedFromTime: string, readonly feeAmount?: { readonly __typename?: 'MonetaryAmount', readonly formatted: string, readonly value: number } | null };

export type CouponFragment = { readonly __typename?: 'Coupon', readonly id: string, readonly name: string, readonly percent: number, readonly amount: number, readonly duration: CouponDurationTypeEnum, readonly movingEligible: boolean, readonly subject: Coupon__Subject, readonly discountDescription: string, readonly discountDisclaimer?: string | null, readonly scheduledCutoff?: string | null, readonly promoCode: string };

export type DraftFragment = { readonly __typename?: 'Draft', readonly id: string, readonly preferredTime?: string | null, readonly latestService?: Lead__ServiceNeeds | null, readonly movingQuoteStartedAt?: string | null, readonly storageQuoteStartedAt?: string | null, readonly protectionPlanSlug?: string | null, readonly address?: { readonly __typename?: 'Draft__Address', readonly street?: string | null, readonly aptsuite?: string | null, readonly city?: string | null, readonly state?: string | null, readonly zip?: string | null, readonly latitude?: number | null, readonly longitude?: number | null } | null, readonly plan?: { readonly __typename?: 'Draft__Plan', readonly name?: string | null } | null, readonly rateGroup?: { readonly __typename?: 'RateGroup', readonly id: string, readonly name: RateGroupKindEnum } | null, readonly movingOriginAttributes?: { readonly __typename?: 'Draft__MovingAddress', readonly aptsuite?: string | null, readonly street?: string | null, readonly city?: string | null, readonly state?: string | null, readonly zip?: string | null, readonly googleAddressType?: string | null, readonly latitude?: number | null, readonly longitude?: number | null, readonly buildingType?: Moving__BuildingTypeEnum | null, readonly floor?: number | null, readonly access?: string | null, readonly stories?: number | null, readonly unitSize?: string | null, readonly squareFootage?: number | null } | null, readonly movingDestinationAttributes?: { readonly __typename?: 'Draft__MovingAddress', readonly aptsuite?: string | null, readonly street?: string | null, readonly city?: string | null, readonly state?: string | null, readonly zip?: string | null, readonly googleAddressType?: string | null, readonly latitude?: number | null, readonly longitude?: number | null, readonly buildingType?: Moving__BuildingTypeEnum | null, readonly floor?: number | null, readonly access?: string | null, readonly stories?: number | null, readonly unitSize?: string | null, readonly squareFootage?: number | null } | null, readonly movingQuote?: { readonly __typename?: 'Moving__QuoteType', readonly id: string, readonly packing: Moving__PackingEnum, readonly moveSize?: Moving__MoveSizeEnum | null, readonly unitTypes: any, readonly materialPackageSetEntry?: { readonly __typename?: 'Moving__PackageSetEntry', readonly id: string, readonly signedID: string, readonly fixedCost: number, readonly package: { readonly __typename?: 'Package', readonly name: string } } | null } | null, readonly lead?: { readonly __typename?: 'Lead', readonly name?: string | null, readonly email?: string | null, readonly phone?: string | null, readonly token: string } | null };

export type ErrorFragment = { readonly __typename: 'Error', readonly errorCode: ErrorCodeEnum, readonly errorMessage: string };

export type GeocodeFragment = { readonly __typename?: 'Geocode', readonly id: string, readonly eligibleForDoorToDoor: boolean, readonly eligibleForMoving: boolean, readonly eligibleForDisposal: boolean, readonly extendedMovingServiceArea: boolean, readonly cityName?: string | null, readonly region?: { readonly __typename?: 'Region', readonly id: string, readonly name: string, readonly tz: string } | null, readonly center?: { readonly __typename?: 'LocatablePoint', readonly lat: number, readonly lng: number } | null };

export type LaborPolicyFragment = { readonly __typename?: 'LaborPolicy', readonly id: string, readonly laborBillingFormat: LaborBillingFormatEnum, readonly perItemPricing: boolean };

export type LaborRateFragment = { readonly __typename?: 'LaborRate', readonly id: string, readonly name: string, readonly amount: number };

export type LatLngFragment = { readonly __typename?: 'LocatablePoint', readonly lat: number, readonly lng: number };

export type LeadFragment = { readonly __typename?: 'Lead', readonly id: string, readonly name?: string | null, readonly email?: string | null, readonly phone?: string | null, readonly zip?: string | null, readonly draft?: { readonly __typename?: 'Draft', readonly id: string, readonly preferredTime?: string | null, readonly latestService?: Lead__ServiceNeeds | null, readonly movingQuoteStartedAt?: string | null, readonly storageQuoteStartedAt?: string | null, readonly protectionPlanSlug?: string | null, readonly address?: { readonly __typename?: 'Draft__Address', readonly street?: string | null, readonly aptsuite?: string | null, readonly city?: string | null, readonly state?: string | null, readonly zip?: string | null, readonly latitude?: number | null, readonly longitude?: number | null } | null, readonly plan?: { readonly __typename?: 'Draft__Plan', readonly name?: string | null } | null, readonly rateGroup?: { readonly __typename?: 'RateGroup', readonly id: string, readonly name: RateGroupKindEnum } | null, readonly movingOriginAttributes?: { readonly __typename?: 'Draft__MovingAddress', readonly aptsuite?: string | null, readonly street?: string | null, readonly city?: string | null, readonly state?: string | null, readonly zip?: string | null, readonly googleAddressType?: string | null, readonly latitude?: number | null, readonly longitude?: number | null, readonly buildingType?: Moving__BuildingTypeEnum | null, readonly floor?: number | null, readonly access?: string | null, readonly stories?: number | null, readonly unitSize?: string | null, readonly squareFootage?: number | null } | null, readonly movingDestinationAttributes?: { readonly __typename?: 'Draft__MovingAddress', readonly aptsuite?: string | null, readonly street?: string | null, readonly city?: string | null, readonly state?: string | null, readonly zip?: string | null, readonly googleAddressType?: string | null, readonly latitude?: number | null, readonly longitude?: number | null, readonly buildingType?: Moving__BuildingTypeEnum | null, readonly floor?: number | null, readonly access?: string | null, readonly stories?: number | null, readonly unitSize?: string | null, readonly squareFootage?: number | null } | null, readonly movingQuote?: { readonly __typename?: 'Moving__QuoteType', readonly id: string, readonly packing: Moving__PackingEnum, readonly moveSize?: Moving__MoveSizeEnum | null, readonly unitTypes: any, readonly materialPackageSetEntry?: { readonly __typename?: 'Moving__PackageSetEntry', readonly id: string, readonly signedID: string, readonly fixedCost: number, readonly package: { readonly __typename?: 'Package', readonly name: string } } | null } | null, readonly lead?: { readonly __typename?: 'Lead', readonly name?: string | null, readonly email?: string | null, readonly phone?: string | null, readonly token: string } | null } | null };

export type LocationReviewFragment = { readonly __typename?: 'Location__Review', readonly id: string, readonly author: string, readonly message: string, readonly rating: number };

export type DraftMovingAddressFragment = { readonly __typename?: 'Draft__MovingAddress', readonly aptsuite?: string | null, readonly street?: string | null, readonly city?: string | null, readonly state?: string | null, readonly zip?: string | null, readonly googleAddressType?: string | null, readonly latitude?: number | null, readonly longitude?: number | null, readonly buildingType?: Moving__BuildingTypeEnum | null, readonly floor?: number | null, readonly access?: string | null, readonly stories?: number | null, readonly unitSize?: string | null, readonly squareFootage?: number | null };

export type Moving__MaterialPackageSetEntryFragment = { readonly __typename?: 'Moving__PackageSetEntry', readonly id: string, readonly signedID: string, readonly fixedCost: number, readonly package: { readonly __typename?: 'Package', readonly name: string } };

export type MoverCountOptionFragment = { readonly __typename?: 'Moving__MoverCountOptionType', readonly moverCount: number, readonly whiteGloveBundle?: Moving__WhiteGloveBundleEnum | null, readonly truckCount: number, readonly recommended: boolean, readonly laborRate?: { readonly __typename?: 'LaborRate', readonly id: string, readonly amount: number } | null, readonly flatRateDetails?: { readonly __typename?: 'Moving__FlatRateDetails', readonly totalAmount: number, readonly laborAmount: number, readonly transportFeeAmount: number, readonly materialsAmount: number } | null };

export type MovingQuoteFragment = { readonly __typename?: 'Moving__QuoteType', readonly id: string, readonly signedID: string, readonly eligibility: boolean, readonly depositInterval: string, readonly formattedDepositInterval: string, readonly unitTypes: any, readonly packing: Moving__PackingEnum, readonly moverSelection?: number | null, readonly reservationDepositAmount?: number | null, readonly truckCount?: number | null, readonly moveSize?: Moving__MoveSizeEnum | null, readonly fullServiceMoverCount?: number | null, readonly longDistanceTransportFee?: number | null, readonly driveDistanceInMiles?: number | null, readonly packingDays?: number | null, readonly estimatedCuft: number, readonly minimumBilledWeight?: number | null, readonly estimatedWeightLowerBound?: number | null, readonly estimatedWeightUpperBound?: number | null, readonly laborRate?: { readonly __typename?: 'LaborRate', readonly id: string, readonly amount: number } | null, readonly materialPackageSetEntry?: { readonly __typename?: 'Moving__PackageSetEntry', readonly id: string, readonly signedID: string, readonly fixedCost: number, readonly package: { readonly __typename?: 'Package', readonly name: string } } | null, readonly movingConfiguration?: { readonly __typename?: 'MovingConfiguration', readonly id: string, readonly requiredLaborDuration: number, readonly travelRateMultiplier: number } | null, readonly pricingSummary?: { readonly __typename?: 'Moving__PricingSummary', readonly totalFixedAmount?: number | null, readonly fixedDuration?: string | null, readonly laborRate: { readonly __typename?: 'LaborRate', readonly amount: number } } | null, readonly moverCountOptions: ReadonlyArray<{ readonly __typename?: 'Moving__MoverCountOptionType', readonly moverCount: number, readonly whiteGloveBundle?: Moving__WhiteGloveBundleEnum | null, readonly truckCount: number, readonly recommended: boolean, readonly laborRate?: { readonly __typename?: 'LaborRate', readonly id: string, readonly amount: number } | null, readonly flatRateDetails?: { readonly __typename?: 'Moving__FlatRateDetails', readonly totalAmount: number, readonly laborAmount: number, readonly transportFeeAmount: number, readonly materialsAmount: number } | null }>, readonly selfMoveMoverCountOptions: ReadonlyArray<{ readonly __typename?: 'Moving__MoverCountOptionType', readonly moverCount: number, readonly whiteGloveBundle?: Moving__WhiteGloveBundleEnum | null, readonly truckCount: number, readonly recommended: boolean, readonly laborRate?: { readonly __typename?: 'LaborRate', readonly id: string, readonly amount: number } | null, readonly flatRateDetails?: { readonly __typename?: 'Moving__FlatRateDetails', readonly totalAmount: number, readonly laborAmount: number, readonly transportFeeAmount: number, readonly materialsAmount: number } | null }>, readonly whiteGloveMoverCountOptions: ReadonlyArray<{ readonly __typename?: 'Moving__MoverCountOptionType', readonly moverCount: number, readonly whiteGloveBundle?: Moving__WhiteGloveBundleEnum | null, readonly truckCount: number, readonly recommended: boolean, readonly laborRate?: { readonly __typename?: 'LaborRate', readonly id: string, readonly amount: number } | null, readonly flatRateDetails?: { readonly __typename?: 'Moving__FlatRateDetails', readonly totalAmount: number, readonly laborAmount: number, readonly transportFeeAmount: number, readonly materialsAmount: number } | null }>, readonly flatRateOptions: ReadonlyArray<{ readonly __typename?: 'Moving__MoverCountOptionType', readonly moverCount: number, readonly whiteGloveBundle?: Moving__WhiteGloveBundleEnum | null, readonly truckCount: number, readonly recommended: boolean, readonly laborRate?: { readonly __typename?: 'LaborRate', readonly id: string, readonly amount: number } | null, readonly flatRateDetails?: { readonly __typename?: 'Moving__FlatRateDetails', readonly totalAmount: number, readonly laborAmount: number, readonly transportFeeAmount: number, readonly materialsAmount: number } | null }>, readonly longDistanceTransportationRate?: { readonly __typename?: 'Moving__LongDistance__TransportationRate', readonly id: string, readonly pricePerPound: number, readonly weightInPounds: { readonly __typename?: 'IntegerRange', readonly begin?: number | null, readonly end?: number | null } } | null };

export type MultidayAvailabilityFragment = { readonly __typename?: 'MultidayAvailability', readonly available: boolean, readonly fromTime: string, readonly tillTime: string, readonly formatted: string, readonly duration?: string | null, readonly formattedFromTime: string, readonly returnAvailabilities: ReadonlyArray<string>, readonly feeAmount?: { readonly __typename?: 'MonetaryAmount', readonly formatted: string, readonly value: number } | null };

export type PackageSetEntryFragment = { readonly __typename?: 'PackageSetEntry', readonly id: string, readonly amount?: number | null, readonly orderSubtype: string, readonly cappedAtOnboardingAmount: boolean, readonly package: { readonly __typename?: 'Package', readonly id: string, readonly name: string, readonly kind: PackageKindEnum } };

export type PlanFragment = { readonly __typename?: 'Plan', readonly id: string, readonly name: string, readonly kind: PlanKindEnum, readonly cuft: number };

export type PricingFragment = { readonly __typename?: 'Pricing', readonly id: string, readonly amount: number, readonly plan: { readonly __typename?: 'Plan', readonly id: string, readonly name: string, readonly kind: PlanKindEnum, readonly cuft: number } };

export type FinalReturnCostSummaryFragment = { readonly __typename?: 'FinalReturnCostSummary', readonly id: string, readonly planId: string, readonly rateGroupKind: RateGroupKindEnum, readonly freeDuration?: string | null };

export type OnboardingCostSummaryFragment = { readonly __typename?: 'OnboardingCostSummary', readonly id: string, readonly planId: string, readonly rateGroupKind: RateGroupKindEnum, readonly freeDuration?: string | null };

export type PricingGroupLaborEntryFragment = { readonly __typename?: 'PricingGroupLaborEntry', readonly id: string, readonly rateGroup?: { readonly __typename?: 'RateGroup', readonly id: string, readonly name: RateGroupKindEnum } | null, readonly laborPolicy: { readonly __typename?: 'LaborPolicy', readonly id: string, readonly laborBillingFormat: LaborBillingFormatEnum, readonly perItemPricing: boolean }, readonly storageTerm: { readonly __typename?: 'StorageTerm', readonly id: string, readonly name: string, readonly rateGroup: { readonly __typename?: 'RateGroup', readonly id: string, readonly name: RateGroupKindEnum } } };

export type PricingGroupPricingEntryFragment = { readonly __typename?: 'PricingGroupPricingEntry', readonly id: string, readonly rateGroup?: { readonly __typename?: 'RateGroup', readonly id: string, readonly name: RateGroupKindEnum } | null, readonly pricing: { readonly __typename?: 'Pricing', readonly id: string, readonly amount: number, readonly plan: { readonly __typename?: 'Plan', readonly id: string, readonly name: string, readonly kind: PlanKindEnum, readonly cuft: number } } };

export type PricingSetFragment = { readonly __typename?: 'PricingSet', readonly id: string, readonly quoteId?: string | null, readonly marketPricingVariantLabel?: string | null, readonly storagePricingGroupEntries: ReadonlyArray<{ readonly __typename?: 'PricingGroupPricingEntry', readonly id: string, readonly rateGroup?: { readonly __typename?: 'RateGroup', readonly id: string, readonly name: RateGroupKindEnum } | null, readonly pricing: { readonly __typename?: 'Pricing', readonly id: string, readonly amount: number, readonly plan: { readonly __typename?: 'Plan', readonly id: string, readonly name: string, readonly kind: PlanKindEnum, readonly cuft: number } } }>, readonly laborPricingGroupEntries: ReadonlyArray<{ readonly __typename?: 'PricingGroupLaborEntry', readonly id: string, readonly rateGroup?: { readonly __typename?: 'RateGroup', readonly id: string, readonly name: RateGroupKindEnum } | null, readonly laborPolicy: { readonly __typename?: 'LaborPolicy', readonly id: string, readonly laborBillingFormat: LaborBillingFormatEnum, readonly perItemPricing: boolean }, readonly storageTerm: { readonly __typename?: 'StorageTerm', readonly id: string, readonly name: string, readonly rateGroup: { readonly __typename?: 'RateGroup', readonly id: string, readonly name: RateGroupKindEnum } } }> };

export type QualifiedContactLinkFragment = { readonly __typename?: 'QualifiedContact__Link', readonly id: string, readonly text: string, readonly url: string };

export type QualifiedContentTopicFragment = { readonly __typename?: 'QualifiedContact__Topic', readonly id: string, readonly title: string, readonly content: string, readonly section: QualifiedContact__Topic__Section, readonly subjects?: ReadonlyArray<QualifiedContact__Topic__Subject> | null, readonly links: ReadonlyArray<{ readonly __typename?: 'QualifiedContact__Link', readonly id: string, readonly text: string, readonly url: string }> };

export type RateGroupFragment = { readonly __typename?: 'RateGroup', readonly id: string, readonly name: RateGroupKindEnum };

export type ReferralPromoFragment = { readonly __typename?: 'ReferralPromo', readonly name: string, readonly code: string, readonly coupons: ReadonlyArray<{ readonly __typename?: 'Coupon', readonly id: string, readonly name: string, readonly percent: number, readonly amount: number, readonly duration: CouponDurationTypeEnum, readonly movingEligible: boolean, readonly subject: Coupon__Subject, readonly discountDescription: string, readonly discountDisclaimer?: string | null, readonly scheduledCutoff?: string | null, readonly promoCode: string }> };

export type StorageBundleFragment = { readonly __typename?: 'Pricing__Bundle', readonly id: string, readonly name: string, readonly kind: DoorToDoor__BundleEnum, readonly packageSetEntry?: { readonly __typename?: 'PackageSetEntry', readonly id: string, readonly amount?: number | null } | null };

export type StorageTermFragment = { readonly __typename?: 'StorageTerm', readonly id: string, readonly name: string, readonly rateGroup: { readonly __typename?: 'RateGroup', readonly id: string, readonly name: RateGroupKindEnum } };

export type AppointmentQuoteCreateMutationVariables = Exact<{
  zip: Scalars['String'];
  cuft: Scalars['Float'];
  rateGroupId: Scalars['ID'];
  quotableId: Scalars['ID'];
  quotableType: Pricing__QuotableEnum;
  source: Pricing__SourceEnum;
}>;


export type AppointmentQuoteCreateMutation = { readonly __typename?: 'Mutation', readonly appointmentQuoteCreate?: { readonly __typename?: 'AppointmentQuoteCreatePayload', readonly status: Status, readonly laborRate: { readonly __typename?: 'LaborRate', readonly id: string, readonly name: string, readonly amount: number }, readonly onboardingPackageSetEntries: ReadonlyArray<{ readonly __typename?: 'PackageSetEntry', readonly id: string, readonly amount?: number | null, readonly orderSubtype: string, readonly cappedAtOnboardingAmount: boolean, readonly package: { readonly __typename?: 'Package', readonly id: string, readonly name: string, readonly kind: PackageKindEnum } }>, readonly finalPackageSetEntries: ReadonlyArray<{ readonly __typename?: 'PackageSetEntry', readonly id: string, readonly amount?: number | null, readonly orderSubtype: string, readonly cappedAtOnboardingAmount: boolean, readonly package: { readonly __typename?: 'Package', readonly id: string, readonly name: string, readonly kind: PackageKindEnum } }>, readonly quote?: { readonly __typename?: 'AppointmentQuote', readonly id: string } | null } | null };

export type ZendeskCallbackRequestCreateMutationVariables = Exact<{
  leadID: Scalars['ID'];
  contactPreference: CustomerTicket__ContactPreference;
  callbackAt: Scalars['DateTime'];
  tags?: InputMaybe<ReadonlyArray<Scalars['String']> | Scalars['String']>;
}>;


export type ZendeskCallbackRequestCreateMutation = { readonly __typename?: 'Mutation', readonly result?: { readonly __typename?: 'ZendeskCallbackRequestCreatePayload', readonly status: Status, readonly error?: { readonly __typename: 'Error', readonly errorCode: ErrorCodeEnum, readonly errorMessage: string } | null } | null };

export type DoorToDoorOnboardingReserveMutationVariables = Exact<{
  input: DoorToDoor__OnboardingInputType;
}>;


export type DoorToDoorOnboardingReserveMutation = { readonly __typename?: 'Mutation', readonly result?: { readonly __typename?: 'DoorToDoor__Onboarding__CreatePayload', readonly status: Status, readonly orderToken?: string | null, readonly orderID?: string | null, readonly accountPortalUrl?: string | null, readonly error?: { readonly __typename: 'Error', readonly errorCode: ErrorCodeEnum, readonly errorMessage: string } | null } | null };

export type DraftUpsertMutationVariables = Exact<{
  input: DraftInput;
}>;


export type DraftUpsertMutation = { readonly __typename?: 'Mutation', readonly draftUpsert?: { readonly __typename?: 'DraftUpsertPayload', readonly status: Status, readonly draft: { readonly __typename?: 'Draft', readonly id: string, readonly preferredTime?: string | null, readonly latestService?: Lead__ServiceNeeds | null, readonly movingQuoteStartedAt?: string | null, readonly storageQuoteStartedAt?: string | null, readonly protectionPlanSlug?: string | null, readonly address?: { readonly __typename?: 'Draft__Address', readonly street?: string | null, readonly aptsuite?: string | null, readonly city?: string | null, readonly state?: string | null, readonly zip?: string | null, readonly latitude?: number | null, readonly longitude?: number | null } | null, readonly plan?: { readonly __typename?: 'Draft__Plan', readonly name?: string | null } | null, readonly rateGroup?: { readonly __typename?: 'RateGroup', readonly id: string, readonly name: RateGroupKindEnum } | null, readonly movingOriginAttributes?: { readonly __typename?: 'Draft__MovingAddress', readonly aptsuite?: string | null, readonly street?: string | null, readonly city?: string | null, readonly state?: string | null, readonly zip?: string | null, readonly googleAddressType?: string | null, readonly latitude?: number | null, readonly longitude?: number | null, readonly buildingType?: Moving__BuildingTypeEnum | null, readonly floor?: number | null, readonly access?: string | null, readonly stories?: number | null, readonly unitSize?: string | null, readonly squareFootage?: number | null } | null, readonly movingDestinationAttributes?: { readonly __typename?: 'Draft__MovingAddress', readonly aptsuite?: string | null, readonly street?: string | null, readonly city?: string | null, readonly state?: string | null, readonly zip?: string | null, readonly googleAddressType?: string | null, readonly latitude?: number | null, readonly longitude?: number | null, readonly buildingType?: Moving__BuildingTypeEnum | null, readonly floor?: number | null, readonly access?: string | null, readonly stories?: number | null, readonly unitSize?: string | null, readonly squareFootage?: number | null } | null, readonly movingQuote?: { readonly __typename?: 'Moving__QuoteType', readonly id: string, readonly packing: Moving__PackingEnum, readonly moveSize?: Moving__MoveSizeEnum | null, readonly unitTypes: any, readonly materialPackageSetEntry?: { readonly __typename?: 'Moving__PackageSetEntry', readonly id: string, readonly signedID: string, readonly fixedCost: number, readonly package: { readonly __typename?: 'Package', readonly name: string } } | null } | null, readonly lead?: { readonly __typename?: 'Lead', readonly name?: string | null, readonly email?: string | null, readonly phone?: string | null, readonly token: string } | null } } | null };

export type FlowStepTransitionMutationVariables = Exact<{
  input: FlowStepTransitionInput;
}>;


export type FlowStepTransitionMutation = { readonly __typename?: 'Mutation', readonly result?: { readonly __typename?: 'FlowStepTransitionPayload', readonly status: Status } | null };

export type LeadCreateMutationVariables = Exact<{
  input: LeadInput;
  validateCustomerStatus?: InputMaybe<Scalars['Boolean']>;
}>;


export type LeadCreateMutation = { readonly __typename?: 'Mutation', readonly result?: { readonly __typename?: 'LeadCreatePayload', readonly status: Status, readonly lead?: { readonly __typename?: 'Lead', readonly id: string, readonly currentStorageCustomer: boolean, readonly token: string } | null, readonly error?: { readonly __typename: 'Error', readonly errorCode: ErrorCodeEnum, readonly errorMessage: string } | null } | null };

export type MovingMaterialPackageSetEntriesFetchMutationVariables = Exact<{
  signedQuoteID: Scalars['ID'];
}>;


export type MovingMaterialPackageSetEntriesFetchMutation = { readonly __typename?: 'Mutation', readonly materialPackageSetEntriesFetch?: { readonly __typename?: 'Moving__MaterialPackageSetEntriesFetchPayload', readonly error?: string | null, readonly status: Status, readonly materialPackageSetEntries: ReadonlyArray<{ readonly __typename?: 'Moving__PackageSetEntry', readonly id: string, readonly signedID: string, readonly fixedCost: number, readonly package: { readonly __typename?: 'Package', readonly name: string } }> } | null };

export type MfaAttemptMakeMutationVariables = Exact<{
  input: Mfa__AttemptInput;
}>;


export type MfaAttemptMakeMutation = { readonly __typename?: 'Mutation', readonly mfaAttemptMake?: { readonly __typename?: 'MFA__MakeAttemptPayload', readonly error?: string | null, readonly status: Status, readonly lead?: { readonly __typename?: 'Lead', readonly token: string } | null, readonly customer?: { readonly __typename?: 'Customer', readonly token: string } | null } | null };

export type MfaRequestCreateMutationVariables = Exact<{
  input: Mfa__RequestInput;
}>;


export type MfaRequestCreateMutation = { readonly __typename?: 'Mutation', readonly mfaRequestCreate?: { readonly __typename?: 'MFA__RequestCreatePayload', readonly status: Status, readonly error?: string | null, readonly request?: { readonly __typename?: 'MFA__Request', readonly id: string } | null } | null };

export type MoveCreateMutationVariables = Exact<{
  input: Moving__MoveInput;
  storagePlanInput?: InputMaybe<Moving__StoragePlanInput>;
}>;


export type MoveCreateMutation = { readonly __typename?: 'Mutation', readonly moveCreate?: { readonly __typename?: 'Moving__MoveCreatePayload', readonly status: Status, readonly orderToken?: string | null, readonly orderID?: string | null, readonly accountPortalUrl?: string | null, readonly isExistingCustomer?: boolean | null, readonly error?: { readonly __typename: 'Error', readonly errorCode: ErrorCodeEnum, readonly errorMessage: string } | null } | null };

export type MovingQuoteCreateMutationVariables = Exact<{
  input: Moving__QuoteInput;
}>;


export type MovingQuoteCreateMutation = { readonly __typename?: 'Mutation', readonly movingQuoteCreate?: { readonly __typename?: 'Moving__QuoteCreatePayload', readonly status: Status, readonly error?: string | null, readonly quote?: { readonly __typename?: 'Moving__QuoteType', readonly id: string, readonly signedID: string, readonly eligibility: boolean, readonly depositInterval: string, readonly formattedDepositInterval: string, readonly unitTypes: any, readonly packing: Moving__PackingEnum, readonly moverSelection?: number | null, readonly reservationDepositAmount?: number | null, readonly truckCount?: number | null, readonly moveSize?: Moving__MoveSizeEnum | null, readonly fullServiceMoverCount?: number | null, readonly longDistanceTransportFee?: number | null, readonly driveDistanceInMiles?: number | null, readonly packingDays?: number | null, readonly estimatedCuft: number, readonly minimumBilledWeight?: number | null, readonly estimatedWeightLowerBound?: number | null, readonly estimatedWeightUpperBound?: number | null, readonly laborRate?: { readonly __typename?: 'LaborRate', readonly id: string, readonly amount: number } | null, readonly materialPackageSetEntry?: { readonly __typename?: 'Moving__PackageSetEntry', readonly id: string, readonly signedID: string, readonly fixedCost: number, readonly package: { readonly __typename?: 'Package', readonly name: string } } | null, readonly movingConfiguration?: { readonly __typename?: 'MovingConfiguration', readonly id: string, readonly requiredLaborDuration: number, readonly travelRateMultiplier: number } | null, readonly pricingSummary?: { readonly __typename?: 'Moving__PricingSummary', readonly totalFixedAmount?: number | null, readonly fixedDuration?: string | null, readonly laborRate: { readonly __typename?: 'LaborRate', readonly amount: number } } | null, readonly moverCountOptions: ReadonlyArray<{ readonly __typename?: 'Moving__MoverCountOptionType', readonly moverCount: number, readonly whiteGloveBundle?: Moving__WhiteGloveBundleEnum | null, readonly truckCount: number, readonly recommended: boolean, readonly laborRate?: { readonly __typename?: 'LaborRate', readonly id: string, readonly amount: number } | null, readonly flatRateDetails?: { readonly __typename?: 'Moving__FlatRateDetails', readonly totalAmount: number, readonly laborAmount: number, readonly transportFeeAmount: number, readonly materialsAmount: number } | null }>, readonly selfMoveMoverCountOptions: ReadonlyArray<{ readonly __typename?: 'Moving__MoverCountOptionType', readonly moverCount: number, readonly whiteGloveBundle?: Moving__WhiteGloveBundleEnum | null, readonly truckCount: number, readonly recommended: boolean, readonly laborRate?: { readonly __typename?: 'LaborRate', readonly id: string, readonly amount: number } | null, readonly flatRateDetails?: { readonly __typename?: 'Moving__FlatRateDetails', readonly totalAmount: number, readonly laborAmount: number, readonly transportFeeAmount: number, readonly materialsAmount: number } | null }>, readonly whiteGloveMoverCountOptions: ReadonlyArray<{ readonly __typename?: 'Moving__MoverCountOptionType', readonly moverCount: number, readonly whiteGloveBundle?: Moving__WhiteGloveBundleEnum | null, readonly truckCount: number, readonly recommended: boolean, readonly laborRate?: { readonly __typename?: 'LaborRate', readonly id: string, readonly amount: number } | null, readonly flatRateDetails?: { readonly __typename?: 'Moving__FlatRateDetails', readonly totalAmount: number, readonly laborAmount: number, readonly transportFeeAmount: number, readonly materialsAmount: number } | null }>, readonly flatRateOptions: ReadonlyArray<{ readonly __typename?: 'Moving__MoverCountOptionType', readonly moverCount: number, readonly whiteGloveBundle?: Moving__WhiteGloveBundleEnum | null, readonly truckCount: number, readonly recommended: boolean, readonly laborRate?: { readonly __typename?: 'LaborRate', readonly id: string, readonly amount: number } | null, readonly flatRateDetails?: { readonly __typename?: 'Moving__FlatRateDetails', readonly totalAmount: number, readonly laborAmount: number, readonly transportFeeAmount: number, readonly materialsAmount: number } | null }>, readonly longDistanceTransportationRate?: { readonly __typename?: 'Moving__LongDistance__TransportationRate', readonly id: string, readonly pricePerPound: number, readonly weightInPounds: { readonly __typename?: 'IntegerRange', readonly begin?: number | null, readonly end?: number | null } } | null } | null } | null };

export type ReviewSaveMutationVariables = Exact<{
  input: ReviewInput;
}>;


export type ReviewSaveMutation = { readonly __typename?: 'Mutation', readonly reviewSave: { readonly __typename?: 'ReviewSavePayload', readonly status: Status } };

export type AvailabilitiesQueryVariables = Exact<{
  input: AvailabilitiesInput;
}>;


export type AvailabilitiesQuery = { readonly __typename?: 'Query', readonly availabilities: ReadonlyArray<{ readonly __typename?: 'Availability', readonly available: boolean, readonly fromTime: string, readonly tillTime: string, readonly formatted: string, readonly duration?: string | null, readonly formattedFromTime: string, readonly feeAmount?: { readonly __typename?: 'MonetaryAmount', readonly formatted: string, readonly value: number } | null }> };

export type CallbackWindowsQueryVariables = Exact<{
  department?: InputMaybe<CallbackDepartment>;
}>;


export type CallbackWindowsQuery = { readonly __typename?: 'Query', readonly allowImmediateCallback: boolean, readonly callbackWindows: ReadonlyArray<{ readonly __typename?: 'CallbackWindow', readonly time: string, readonly duration: string }> };

export type CityQueryVariables = Exact<{
  state: Scalars['ID'];
  city: Scalars['ID'];
  service: Location__Service;
}>;


export type CityQuery = { readonly __typename?: 'Query', readonly state?: { readonly __typename?: 'Location__State', readonly id: string, readonly slug: string, readonly name: string, readonly code: string, readonly city?: { readonly __typename?: 'Location__City', readonly id: string, readonly slug: string, readonly name: string, readonly center: { readonly __typename?: 'LocatablePoint', readonly lat: number, readonly lng: number }, readonly content?: { readonly __typename?: 'Location__Content', readonly id: string, readonly title?: string | null, readonly headline?: string | null, readonly description?: string | null, readonly blurb: string, readonly service: Location__Service, readonly heroAlt?: string | null, readonly heroImage?: { readonly __typename?: 'ActiveStorageAttachment', readonly id: string, readonly imgixURL: string } | null, readonly reviews: ReadonlyArray<{ readonly __typename?: 'Location__Review', readonly id: string, readonly author: string, readonly message: string, readonly rating: number }> } | null, readonly neighborhoods: ReadonlyArray<{ readonly __typename?: 'Location__Neighborhood', readonly id: string, readonly slug: string, readonly name: string }> } | null } | null };

export type CouponQueryVariables = Exact<{
  code: Scalars['String'];
  service?: InputMaybe<Scalars['String']>;
}>;


export type CouponQuery = { readonly __typename?: 'Query', readonly coupon: { readonly __typename?: 'Coupon', readonly id: string, readonly name: string, readonly percent: number, readonly amount: number, readonly duration: CouponDurationTypeEnum, readonly movingEligible: boolean, readonly subject: Coupon__Subject, readonly discountDescription: string, readonly discountDisclaimer?: string | null, readonly scheduledCutoff?: string | null, readonly promoCode: string } | { readonly __typename: 'Error', readonly errorCode: ErrorCodeEnum, readonly errorMessage: string } };

export type ReonboardingCustomerQueryVariables = Exact<{
  customerToken: Scalars['String'];
}>;


export type ReonboardingCustomerQuery = { readonly __typename?: 'Query', readonly reonboardingCustomer?: { readonly __typename?: 'Customer', readonly id: string, readonly currentStorageCustomer: boolean, readonly name: string, readonly email: string, readonly phone?: string | null, readonly address?: { readonly __typename?: 'Address', readonly zip: string, readonly street: string, readonly aptsuite?: string | null, readonly city: string, readonly state: string } | null, readonly defaultSource?: { readonly __typename?: 'Source', readonly number?: string | null, readonly fundingType?: string | null } | null } | null };

export type DisposalCategoryPricingQueryVariables = Exact<{ [key: string]: never; }>;


export type DisposalCategoryPricingQuery = { readonly __typename?: 'Query', readonly disposalCategoryPricing: ReadonlyArray<{ readonly __typename?: 'Disposal__CategoryPricingDescriptor', readonly category: string, readonly minimum: number }> };

export type DraftQueryVariables = Exact<{ [key: string]: never; }>;


export type DraftQuery = { readonly __typename?: 'Query', readonly draft?: { readonly __typename?: 'Draft', readonly id: string, readonly preferredTime?: string | null, readonly latestService?: Lead__ServiceNeeds | null, readonly movingQuoteStartedAt?: string | null, readonly storageQuoteStartedAt?: string | null, readonly protectionPlanSlug?: string | null, readonly address?: { readonly __typename?: 'Draft__Address', readonly street?: string | null, readonly aptsuite?: string | null, readonly city?: string | null, readonly state?: string | null, readonly zip?: string | null, readonly latitude?: number | null, readonly longitude?: number | null } | null, readonly plan?: { readonly __typename?: 'Draft__Plan', readonly name?: string | null } | null, readonly rateGroup?: { readonly __typename?: 'RateGroup', readonly id: string, readonly name: RateGroupKindEnum } | null, readonly movingOriginAttributes?: { readonly __typename?: 'Draft__MovingAddress', readonly aptsuite?: string | null, readonly street?: string | null, readonly city?: string | null, readonly state?: string | null, readonly zip?: string | null, readonly googleAddressType?: string | null, readonly latitude?: number | null, readonly longitude?: number | null, readonly buildingType?: Moving__BuildingTypeEnum | null, readonly floor?: number | null, readonly access?: string | null, readonly stories?: number | null, readonly unitSize?: string | null, readonly squareFootage?: number | null } | null, readonly movingDestinationAttributes?: { readonly __typename?: 'Draft__MovingAddress', readonly aptsuite?: string | null, readonly street?: string | null, readonly city?: string | null, readonly state?: string | null, readonly zip?: string | null, readonly googleAddressType?: string | null, readonly latitude?: number | null, readonly longitude?: number | null, readonly buildingType?: Moving__BuildingTypeEnum | null, readonly floor?: number | null, readonly access?: string | null, readonly stories?: number | null, readonly unitSize?: string | null, readonly squareFootage?: number | null } | null, readonly movingQuote?: { readonly __typename?: 'Moving__QuoteType', readonly id: string, readonly packing: Moving__PackingEnum, readonly moveSize?: Moving__MoveSizeEnum | null, readonly unitTypes: any, readonly materialPackageSetEntry?: { readonly __typename?: 'Moving__PackageSetEntry', readonly id: string, readonly signedID: string, readonly fixedCost: number, readonly package: { readonly __typename?: 'Package', readonly name: string } } | null } | null, readonly lead?: { readonly __typename?: 'Lead', readonly name?: string | null, readonly email?: string | null, readonly phone?: string | null, readonly token: string } | null } | null };

export type EstimatedMoversQueryVariables = Exact<{
  planId: Scalars['ID'];
  postalCode?: InputMaybe<Scalars['String']>;
}>;


export type EstimatedMoversQuery = { readonly __typename?: 'Query', readonly estimatedMovers: number };

export type FinalReturnCostSummariesQueryVariables = Exact<{
  pricingSetId: Scalars['ID'];
  planIds: ReadonlyArray<Scalars['ID']> | Scalars['ID'];
  rateGroupKinds: ReadonlyArray<RateGroupKindEnum> | RateGroupKindEnum;
}>;


export type FinalReturnCostSummariesQuery = { readonly __typename?: 'Query', readonly result: ReadonlyArray<{ readonly __typename?: 'FinalReturnCostSummary', readonly id: string, readonly planId: string, readonly rateGroupKind: RateGroupKindEnum, readonly freeDuration?: string | null }> };

export type GeocodeQueryVariables = Exact<{
  zip: Scalars['String'];
}>;


export type GeocodeQuery = { readonly __typename?: 'Query', readonly geocode?: { readonly __typename?: 'Geocode', readonly id: string, readonly eligibleForDoorToDoor: boolean, readonly eligibleForMoving: boolean, readonly eligibleForDisposal: boolean, readonly extendedMovingServiceArea: boolean, readonly cityName?: string | null, readonly region?: { readonly __typename?: 'Region', readonly id: string, readonly name: string, readonly tz: string } | null, readonly center?: { readonly __typename?: 'LocatablePoint', readonly lat: number, readonly lng: number } | null } | null };

export type IsExistingCustomerQueryVariables = Exact<{
  email: Scalars['String'];
  phoneNumber: Scalars['String'];
}>;


export type IsExistingCustomerQuery = { readonly __typename?: 'Query', readonly isExistingCustomer: boolean };

export type LeadQueryVariables = Exact<{
  token: Scalars['ID'];
}>;


export type LeadQuery = { readonly __typename?: 'Query', readonly lead: { readonly __typename?: 'Lead', readonly id: string, readonly name?: string | null, readonly email?: string | null, readonly phone?: string | null, readonly zip?: string | null, readonly draft?: { readonly __typename?: 'Draft', readonly id: string, readonly preferredTime?: string | null, readonly latestService?: Lead__ServiceNeeds | null, readonly movingQuoteStartedAt?: string | null, readonly storageQuoteStartedAt?: string | null, readonly protectionPlanSlug?: string | null, readonly address?: { readonly __typename?: 'Draft__Address', readonly street?: string | null, readonly aptsuite?: string | null, readonly city?: string | null, readonly state?: string | null, readonly zip?: string | null, readonly latitude?: number | null, readonly longitude?: number | null } | null, readonly plan?: { readonly __typename?: 'Draft__Plan', readonly name?: string | null } | null, readonly rateGroup?: { readonly __typename?: 'RateGroup', readonly id: string, readonly name: RateGroupKindEnum } | null, readonly movingOriginAttributes?: { readonly __typename?: 'Draft__MovingAddress', readonly aptsuite?: string | null, readonly street?: string | null, readonly city?: string | null, readonly state?: string | null, readonly zip?: string | null, readonly googleAddressType?: string | null, readonly latitude?: number | null, readonly longitude?: number | null, readonly buildingType?: Moving__BuildingTypeEnum | null, readonly floor?: number | null, readonly access?: string | null, readonly stories?: number | null, readonly unitSize?: string | null, readonly squareFootage?: number | null } | null, readonly movingDestinationAttributes?: { readonly __typename?: 'Draft__MovingAddress', readonly aptsuite?: string | null, readonly street?: string | null, readonly city?: string | null, readonly state?: string | null, readonly zip?: string | null, readonly googleAddressType?: string | null, readonly latitude?: number | null, readonly longitude?: number | null, readonly buildingType?: Moving__BuildingTypeEnum | null, readonly floor?: number | null, readonly access?: string | null, readonly stories?: number | null, readonly unitSize?: string | null, readonly squareFootage?: number | null } | null, readonly movingQuote?: { readonly __typename?: 'Moving__QuoteType', readonly id: string, readonly packing: Moving__PackingEnum, readonly moveSize?: Moving__MoveSizeEnum | null, readonly unitTypes: any, readonly materialPackageSetEntry?: { readonly __typename?: 'Moving__PackageSetEntry', readonly id: string, readonly signedID: string, readonly fixedCost: number, readonly package: { readonly __typename?: 'Package', readonly name: string } } | null } | null, readonly lead?: { readonly __typename?: 'Lead', readonly name?: string | null, readonly email?: string | null, readonly phone?: string | null, readonly token: string } | null } | null } };

export type LocationLinksQueryVariables = Exact<{ [key: string]: never; }>;


export type LocationLinksQuery = { readonly __typename?: 'Query', readonly states: ReadonlyArray<{ readonly __typename?: 'Location__State', readonly id: string, readonly code: string, readonly name: string, readonly slug: string, readonly cities: ReadonlyArray<{ readonly __typename?: 'Location__City', readonly id: string, readonly slug: string, readonly name: string, readonly services: ReadonlyArray<Location__Service>, readonly center: { readonly __typename?: 'LocatablePoint', readonly lat: number, readonly lng: number } }> }> };

export type LongDistanceAvailabilitiesQueryVariables = Exact<{
  input: AvailabilitiesInput;
}>;


export type LongDistanceAvailabilitiesQuery = { readonly __typename?: 'Query', readonly availabilities: ReadonlyArray<{ readonly __typename?: 'MultidayAvailability', readonly available: boolean, readonly fromTime: string, readonly tillTime: string, readonly formatted: string, readonly duration?: string | null, readonly formattedFromTime: string, readonly returnAvailabilities: ReadonlyArray<string>, readonly feeAmount?: { readonly __typename?: 'MonetaryAmount', readonly formatted: string, readonly value: number } | null }> };

export type MovingRouteSummaryQueryVariables = Exact<{
  destinationAddress: AddressInput;
  originAddress: AddressInput;
  unitTypes?: InputMaybe<Scalars['UnitTypes']>;
  moveSize?: InputMaybe<Moving__MoveSizeEnum>;
}>;


export type MovingRouteSummaryQuery = { readonly __typename?: 'Query', readonly movingRouteSummary: { readonly __typename?: 'Moving__RouteSummary', readonly validMoveRoute: boolean, readonly longDistance: boolean, readonly extendedDestinationServiceArea: boolean } };

export type NeighborhoodQueryVariables = Exact<{
  state: Scalars['ID'];
  city: Scalars['ID'];
  neighborhood: Scalars['ID'];
  service: Location__Service;
}>;


export type NeighborhoodQuery = { readonly __typename?: 'Query', readonly state?: { readonly __typename?: 'Location__State', readonly id: string, readonly slug: string, readonly name: string, readonly code: string, readonly city?: { readonly __typename?: 'Location__City', readonly id: string, readonly slug: string, readonly name: string, readonly center: { readonly __typename?: 'LocatablePoint', readonly lat: number, readonly lng: number }, readonly content?: { readonly __typename?: 'Location__Content', readonly reviews: ReadonlyArray<{ readonly __typename?: 'Location__Review', readonly id: string, readonly author: string, readonly message: string, readonly rating: number }> } | null, readonly neighborhood?: { readonly __typename?: 'Location__Neighborhood', readonly id: string, readonly slug: string, readonly name: string, readonly content?: { readonly __typename?: 'Location__Content', readonly id: string, readonly title?: string | null, readonly headline?: string | null, readonly description?: string | null, readonly blurb: string, readonly service: Location__Service, readonly heroAlt?: string | null, readonly heroImage?: { readonly __typename?: 'ActiveStorageAttachment', readonly id: string, readonly imgixURL: string } | null, readonly reviews: ReadonlyArray<{ readonly __typename?: 'Location__Review', readonly id: string, readonly author: string, readonly message: string, readonly rating: number }> } | null } | null, readonly neighborhoods: ReadonlyArray<{ readonly __typename?: 'Location__Neighborhood', readonly id: string, readonly slug: string, readonly name: string }> } | null } | null };

export type OnboardingCostSummariesQueryVariables = Exact<{
  pricingSetId: Scalars['ID'];
  planIds: ReadonlyArray<Scalars['ID']> | Scalars['ID'];
  rateGroupKinds: ReadonlyArray<RateGroupKindEnum> | RateGroupKindEnum;
}>;


export type OnboardingCostSummariesQuery = { readonly __typename?: 'Query', readonly result: ReadonlyArray<{ readonly __typename?: 'OnboardingCostSummary', readonly id: string, readonly planId: string, readonly rateGroupKind: RateGroupKindEnum, readonly freeDuration?: string | null }> };

export type PricingSetQueryVariables = Exact<{
  zip: Scalars['String'];
  visitorToken: Scalars['String'];
}>;


export type PricingSetQuery = { readonly __typename?: 'Query', readonly pricingSet?: { readonly __typename?: 'PricingSet', readonly id: string, readonly quoteId?: string | null, readonly marketPricingVariantLabel?: string | null, readonly storagePricingGroupEntries: ReadonlyArray<{ readonly __typename?: 'PricingGroupPricingEntry', readonly id: string, readonly rateGroup?: { readonly __typename?: 'RateGroup', readonly id: string, readonly name: RateGroupKindEnum } | null, readonly pricing: { readonly __typename?: 'Pricing', readonly id: string, readonly amount: number, readonly plan: { readonly __typename?: 'Plan', readonly id: string, readonly name: string, readonly kind: PlanKindEnum, readonly cuft: number } } }>, readonly laborPricingGroupEntries: ReadonlyArray<{ readonly __typename?: 'PricingGroupLaborEntry', readonly id: string, readonly rateGroup?: { readonly __typename?: 'RateGroup', readonly id: string, readonly name: RateGroupKindEnum } | null, readonly laborPolicy: { readonly __typename?: 'LaborPolicy', readonly id: string, readonly laborBillingFormat: LaborBillingFormatEnum, readonly perItemPricing: boolean }, readonly storageTerm: { readonly __typename?: 'StorageTerm', readonly id: string, readonly name: string, readonly rateGroup: { readonly __typename?: 'RateGroup', readonly id: string, readonly name: RateGroupKindEnum } } }> } | null };

export type QualfiedContactTopicsQueryVariables = Exact<{ [key: string]: never; }>;


export type QualfiedContactTopicsQuery = { readonly __typename?: 'Query', readonly topics: ReadonlyArray<{ readonly __typename?: 'QualifiedContact__Topic', readonly id: string, readonly title: string, readonly content: string, readonly section: QualifiedContact__Topic__Section, readonly subjects?: ReadonlyArray<QualifiedContact__Topic__Subject> | null, readonly links: ReadonlyArray<{ readonly __typename?: 'QualifiedContact__Link', readonly id: string, readonly text: string, readonly url: string }> }> };

export type ReferralQueryVariables = Exact<{
  promoCode: Scalars['String'];
}>;


export type ReferralQuery = { readonly __typename?: 'Query', readonly referral?: { readonly __typename?: 'ReferralPromo', readonly name: string, readonly code: string, readonly coupons: ReadonlyArray<{ readonly __typename?: 'Coupon', readonly id: string, readonly name: string, readonly percent: number, readonly amount: number, readonly duration: CouponDurationTypeEnum, readonly movingEligible: boolean, readonly subject: Coupon__Subject, readonly discountDescription: string, readonly discountDisclaimer?: string | null, readonly scheduledCutoff?: string | null, readonly promoCode: string }> } | null };

export type RouteQueryVariables = Exact<{
  route: Scalars['ID'];
  service: Location__Service;
}>;


export type RouteQuery = { readonly __typename?: 'Query', readonly route?: { readonly __typename?: 'Landing__Location__Route', readonly id: string, readonly slug: string, readonly content?: { readonly __typename?: 'Location__Content', readonly id: string, readonly title?: string | null, readonly headline?: string | null, readonly description?: string | null, readonly blurb: string, readonly service: Location__Service, readonly heroAlt?: string | null, readonly heroImage?: { readonly __typename?: 'ActiveStorageAttachment', readonly id: string, readonly imgixURL: string } | null, readonly reviews: ReadonlyArray<{ readonly __typename?: 'Location__Review', readonly id: string, readonly author: string, readonly message: string, readonly rating: number }> } | null, readonly origin: { readonly __typename?: 'Location__City', readonly id: string, readonly name: string, readonly slug: string, readonly center: { readonly __typename?: 'LocatablePoint', readonly lat: number, readonly lng: number }, readonly state: { readonly __typename?: 'Location__State', readonly id: string, readonly name: string, readonly code: string, readonly slug: string }, readonly content?: { readonly __typename?: 'Location__Content', readonly reviews: ReadonlyArray<{ readonly __typename?: 'Location__Review', readonly id: string, readonly author: string, readonly message: string, readonly rating: number }> } | null, readonly neighborhoods: ReadonlyArray<{ readonly __typename?: 'Location__Neighborhood', readonly id: string, readonly slug: string, readonly name: string }> } | { readonly __typename?: 'Location__Neighborhood', readonly id: string, readonly name: string, readonly slug: string, readonly city: { readonly __typename?: 'Location__City', readonly id: string, readonly name: string, readonly slug: string, readonly center: { readonly __typename?: 'LocatablePoint', readonly lat: number, readonly lng: number }, readonly state: { readonly __typename?: 'Location__State', readonly id: string, readonly name: string, readonly code: string, readonly slug: string }, readonly neighborhoods: ReadonlyArray<{ readonly __typename?: 'Location__Neighborhood', readonly id: string, readonly slug: string, readonly name: string }> }, readonly content?: { readonly __typename?: 'Location__Content', readonly reviews: ReadonlyArray<{ readonly __typename?: 'Location__Review', readonly id: string, readonly author: string, readonly message: string, readonly rating: number }> } | null } | { readonly __typename?: 'Location__State', readonly id: string, readonly name: string, readonly code: string, readonly slug: string }, readonly destination: { readonly __typename?: 'Location__City', readonly id: string, readonly name: string, readonly state: { readonly __typename?: 'Location__State', readonly id: string, readonly name: string } } | { readonly __typename?: 'Location__Neighborhood', readonly id: string, readonly name: string, readonly city: { readonly __typename?: 'Location__City', readonly id: string, readonly name: string, readonly state: { readonly __typename?: 'Location__State', readonly id: string, readonly name: string } } } | { readonly __typename?: 'Location__State', readonly id: string, readonly name: string } } | null };

export type SalesTaxQueryVariables = Exact<{
  zipCode: Scalars['String'];
}>;


export type SalesTaxQuery = { readonly __typename?: 'Query', readonly salesTax: { readonly __typename?: 'TaxRate', readonly percent: number } };

export type SeoRegionPolygonQueryVariables = Exact<{
  state: Scalars['ID'];
  city: Scalars['ID'];
}>;


export type SeoRegionPolygonQuery = { readonly __typename?: 'Query', readonly state?: { readonly __typename?: 'Location__State', readonly id: string, readonly city?: { readonly __typename?: 'Location__City', readonly id: string, readonly polygons: ReadonlyArray<{ readonly __typename?: 'Polygon', readonly paths: ReadonlyArray<ReadonlyArray<{ readonly __typename?: 'LocatablePoint', readonly lat: number, readonly lng: number }>> }> } | null } | null };

export type StorageBundlesQueryVariables = Exact<{
  cuft?: InputMaybe<Scalars['Int']>;
}>;


export type StorageBundlesQuery = { readonly __typename?: 'Query', readonly bundles: ReadonlyArray<{ readonly __typename?: 'Pricing__Bundle', readonly id: string, readonly name: string, readonly kind: DoorToDoor__BundleEnum, readonly packageSetEntry?: { readonly __typename?: 'PackageSetEntry', readonly id: string, readonly amount?: number | null } | null }> };

export const AddressFragmentDoc = gql`
    fragment address on Address {
  id
  street
  aptsuite
  city
  state
  zip
  latitude
  longitude
}
    `;
export const AvailabilityFragmentDoc = gql`
    fragment availability on Availability {
  available
  fromTime
  tillTime
  formatted
  duration
  formattedFromTime
  feeAmount {
    formatted
    value
  }
}
    `;
export const ErrorFragmentDoc = gql`
    fragment error on Error {
  __typename
  errorCode: code
  errorMessage: message
}
    `;
export const LatLngFragmentDoc = gql`
    fragment latLng on LocatablePoint {
  lat: latitude
  lng: longitude
}
    `;
export const GeocodeFragmentDoc = gql`
    fragment geocode on Geocode {
  id
  eligibleForDoorToDoor
  eligibleForMoving
  eligibleForDisposal
  extendedMovingServiceArea
  cityName
  region {
    id
    name
    tz
  }
  center {
    ...latLng
  }
}
    ${LatLngFragmentDoc}`;
export const LaborRateFragmentDoc = gql`
    fragment laborRate on LaborRate {
  id
  name
  amount
}
    `;
export const DraftMovingAddressFragmentDoc = gql`
    fragment draftMovingAddress on Draft__MovingAddress {
  aptsuite
  street
  city
  state
  zip
  googleAddressType
  latitude
  longitude
  buildingType
  floor
  access
  stories
  unitSize
  squareFootage
}
    `;
export const DraftFragmentDoc = gql`
    fragment draft on Draft {
  id
  address {
    street
    aptsuite
    street
    city
    state
    zip
    latitude
    longitude
  }
  plan {
    name
  }
  rateGroup {
    id
    name
  }
  preferredTime
  movingOriginAttributes {
    ...draftMovingAddress
  }
  movingDestinationAttributes {
    ...draftMovingAddress
  }
  movingQuote {
    id
    packing
    moveSize
    unitTypes
    materialPackageSetEntry {
      id
      signedID
      fixedCost
      package {
        name
      }
    }
  }
  latestService
  movingQuoteStartedAt
  storageQuoteStartedAt
  protectionPlanSlug
  lead {
    name
    email
    phone
    token
  }
}
    ${DraftMovingAddressFragmentDoc}`;
export const LeadFragmentDoc = gql`
    fragment lead on Lead {
  id
  name
  email
  phone
  zip
  draft {
    ...draft
  }
}
    ${DraftFragmentDoc}`;
export const LocationReviewFragmentDoc = gql`
    fragment locationReview on Location__Review {
  id
  author
  message
  rating
}
    `;
export const Moving__MaterialPackageSetEntryFragmentDoc = gql`
    fragment Moving__materialPackageSetEntry on Moving__PackageSetEntry {
  id
  signedID
  fixedCost
  package {
    name
  }
}
    `;
export const MoverCountOptionFragmentDoc = gql`
    fragment moverCountOption on Moving__MoverCountOptionType {
  moverCount
  laborRate {
    id
    amount
  }
  flatRateDetails {
    totalAmount
    laborAmount
    transportFeeAmount
    materialsAmount
  }
  whiteGloveBundle
  truckCount
  recommended
}
    `;
export const MovingQuoteFragmentDoc = gql`
    fragment movingQuote on Moving__QuoteType {
  id
  signedID
  eligibility
  depositInterval
  formattedDepositInterval
  unitTypes
  packing
  laborRate {
    id
    amount
  }
  materialPackageSetEntry {
    id
    signedID
    fixedCost
    package {
      name
    }
  }
  moverSelection
  movingConfiguration {
    id
    requiredLaborDuration
    travelRateMultiplier
  }
  reservationDepositAmount
  truckCount
  moveSize
  pricingSummary {
    totalFixedAmount
    fixedDuration
    laborRate {
      amount
    }
  }
  moverCountOptions {
    ...moverCountOption
  }
  selfMoveMoverCountOptions {
    ...moverCountOption
  }
  whiteGloveMoverCountOptions {
    ...moverCountOption
  }
  flatRateOptions {
    ...moverCountOption
  }
  fullServiceMoverCount
  longDistanceTransportFee
  longDistanceTransportationRate {
    id
    pricePerPound
    weightInPounds {
      begin
      end
    }
  }
  driveDistanceInMiles
  packingDays
  estimatedCuft
  minimumBilledWeight
  estimatedWeightLowerBound
  estimatedWeightUpperBound
}
    ${MoverCountOptionFragmentDoc}`;
export const MultidayAvailabilityFragmentDoc = gql`
    fragment multidayAvailability on MultidayAvailability {
  available
  fromTime
  tillTime
  formatted
  duration
  formattedFromTime
  returnAvailabilities
  feeAmount {
    formatted
    value
  }
}
    `;
export const PackageSetEntryFragmentDoc = gql`
    fragment packageSetEntry on PackageSetEntry {
  id
  amount(cuft: $cuft)
  orderSubtype
  cappedAtOnboardingAmount
  package {
    id
    name
    kind
  }
}
    `;
export const FinalReturnCostSummaryFragmentDoc = gql`
    fragment finalReturnCostSummary on FinalReturnCostSummary {
  id
  planId
  rateGroupKind
  freeDuration
}
    `;
export const OnboardingCostSummaryFragmentDoc = gql`
    fragment onboardingCostSummary on OnboardingCostSummary {
  id
  planId
  rateGroupKind
  freeDuration
}
    `;
export const RateGroupFragmentDoc = gql`
    fragment rateGroup on RateGroup {
  id
  name
}
    `;
export const PlanFragmentDoc = gql`
    fragment plan on Plan {
  id
  name
  kind
  cuft
}
    `;
export const PricingFragmentDoc = gql`
    fragment pricing on Pricing {
  id
  amount
  plan {
    ...plan
  }
}
    ${PlanFragmentDoc}`;
export const PricingGroupPricingEntryFragmentDoc = gql`
    fragment pricingGroupPricingEntry on PricingGroupPricingEntry {
  id
  rateGroup {
    ...rateGroup
  }
  pricing {
    ...pricing
  }
}
    ${RateGroupFragmentDoc}
${PricingFragmentDoc}`;
export const LaborPolicyFragmentDoc = gql`
    fragment laborPolicy on LaborPolicy {
  id
  laborBillingFormat
  perItemPricing
}
    `;
export const StorageTermFragmentDoc = gql`
    fragment storageTerm on StorageTerm {
  id
  name
  rateGroup {
    ...rateGroup
  }
}
    ${RateGroupFragmentDoc}`;
export const PricingGroupLaborEntryFragmentDoc = gql`
    fragment pricingGroupLaborEntry on PricingGroupLaborEntry {
  id
  rateGroup {
    ...rateGroup
  }
  laborPolicy {
    ...laborPolicy
  }
  storageTerm {
    ...storageTerm
  }
}
    ${RateGroupFragmentDoc}
${LaborPolicyFragmentDoc}
${StorageTermFragmentDoc}`;
export const PricingSetFragmentDoc = gql`
    fragment pricingSet on PricingSet {
  id
  quoteId
  marketPricingVariantLabel
  storagePricingGroupEntries {
    ...pricingGroupPricingEntry
  }
  laborPricingGroupEntries {
    ...pricingGroupLaborEntry
  }
}
    ${PricingGroupPricingEntryFragmentDoc}
${PricingGroupLaborEntryFragmentDoc}`;
export const QualifiedContactLinkFragmentDoc = gql`
    fragment qualifiedContactLink on QualifiedContact__Link {
  id
  text
  url
}
    `;
export const QualifiedContentTopicFragmentDoc = gql`
    fragment qualifiedContentTopic on QualifiedContact__Topic {
  id
  title
  content
  section
  subjects
  links {
    ...qualifiedContactLink
  }
}
    ${QualifiedContactLinkFragmentDoc}`;
export const CouponFragmentDoc = gql`
    fragment coupon on Coupon {
  id
  name
  promoCode: code
  percent
  amount
  duration
  movingEligible
  subject
  discountDescription
  discountDisclaimer
  scheduledCutoff
}
    `;
export const ReferralPromoFragmentDoc = gql`
    fragment referralPromo on ReferralPromo {
  name
  code
  coupons {
    ...coupon
  }
}
    ${CouponFragmentDoc}`;
export const StorageBundleFragmentDoc = gql`
    fragment storageBundle on Pricing__Bundle {
  id
  name
  kind
  packageSetEntry {
    id
    amount(cuft: 0)
  }
}
    `;
export const ItemCategorySearchDocument = gql`
    query ItemCategorySearch($query: String!) {
  results: itemCategorySearch(query: $query) {
    id
    name
    cuft
  }
}
    `;

/**
 * __useItemCategorySearchQuery__
 *
 * To run a query within a React component, call `useItemCategorySearchQuery` and pass it any options that fit your needs.
 * When your component renders, `useItemCategorySearchQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useItemCategorySearchQuery({
 *   variables: {
 *      query: // value for 'query'
 *   },
 * });
 */
export function useItemCategorySearchQuery(baseOptions: Apollo.QueryHookOptions<ItemCategorySearchQuery, ItemCategorySearchQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ItemCategorySearchQuery, ItemCategorySearchQueryVariables>(ItemCategorySearchDocument, options);
      }
export function useItemCategorySearchLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ItemCategorySearchQuery, ItemCategorySearchQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ItemCategorySearchQuery, ItemCategorySearchQueryVariables>(ItemCategorySearchDocument, options);
        }
export type ItemCategorySearchQueryHookResult = ReturnType<typeof useItemCategorySearchQuery>;
export type ItemCategorySearchLazyQueryHookResult = ReturnType<typeof useItemCategorySearchLazyQuery>;
export type ItemCategorySearchQueryResult = Apollo.QueryResult<ItemCategorySearchQuery, ItemCategorySearchQueryVariables>;
export const AppointmentQuoteCreateDocument = gql`
    mutation AppointmentQuoteCreate($zip: String!, $cuft: Float!, $rateGroupId: ID!, $quotableId: ID!, $quotableType: Pricing__QuotableEnum!, $source: Pricing__SourceEnum!) {
  appointmentQuoteCreate(zip: $zip, cuft: $cuft, rateGroupId: $rateGroupId, quotableId: $quotableId, quotableType: $quotableType, source: $source) {
    status
    laborRate {
      ...laborRate
    }
    onboardingPackageSetEntries {
      ...packageSetEntry
    }
    finalPackageSetEntries {
      ...packageSetEntry
    }
    quote {
      id
    }
  }
}
    ${LaborRateFragmentDoc}
${PackageSetEntryFragmentDoc}`;
export type AppointmentQuoteCreateMutationFn = Apollo.MutationFunction<AppointmentQuoteCreateMutation, AppointmentQuoteCreateMutationVariables>;

/**
 * __useAppointmentQuoteCreateMutation__
 *
 * To run a mutation, you first call `useAppointmentQuoteCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAppointmentQuoteCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [appointmentQuoteCreateMutation, { data, loading, error }] = useAppointmentQuoteCreateMutation({
 *   variables: {
 *      zip: // value for 'zip'
 *      cuft: // value for 'cuft'
 *      rateGroupId: // value for 'rateGroupId'
 *      quotableId: // value for 'quotableId'
 *      quotableType: // value for 'quotableType'
 *      source: // value for 'source'
 *   },
 * });
 */
export function useAppointmentQuoteCreateMutation(baseOptions?: Apollo.MutationHookOptions<AppointmentQuoteCreateMutation, AppointmentQuoteCreateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AppointmentQuoteCreateMutation, AppointmentQuoteCreateMutationVariables>(AppointmentQuoteCreateDocument, options);
      }
export type AppointmentQuoteCreateMutationHookResult = ReturnType<typeof useAppointmentQuoteCreateMutation>;
export type AppointmentQuoteCreateMutationResult = Apollo.MutationResult<AppointmentQuoteCreateMutation>;
export type AppointmentQuoteCreateMutationOptions = Apollo.BaseMutationOptions<AppointmentQuoteCreateMutation, AppointmentQuoteCreateMutationVariables>;
export const ZendeskCallbackRequestCreateDocument = gql`
    mutation ZendeskCallbackRequestCreate($leadID: ID!, $contactPreference: CustomerTicket__ContactPreference!, $callbackAt: DateTime!, $tags: [String!]) {
  result: zendeskCallbackRequestCreate(leadID: $leadID, contactPreference: $contactPreference, callbackAt: $callbackAt, tags: $tags) {
    error {
      ...error
    }
    status
  }
}
    ${ErrorFragmentDoc}`;
export type ZendeskCallbackRequestCreateMutationFn = Apollo.MutationFunction<ZendeskCallbackRequestCreateMutation, ZendeskCallbackRequestCreateMutationVariables>;

/**
 * __useZendeskCallbackRequestCreateMutation__
 *
 * To run a mutation, you first call `useZendeskCallbackRequestCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useZendeskCallbackRequestCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [zendeskCallbackRequestCreateMutation, { data, loading, error }] = useZendeskCallbackRequestCreateMutation({
 *   variables: {
 *      leadID: // value for 'leadID'
 *      contactPreference: // value for 'contactPreference'
 *      callbackAt: // value for 'callbackAt'
 *      tags: // value for 'tags'
 *   },
 * });
 */
export function useZendeskCallbackRequestCreateMutation(baseOptions?: Apollo.MutationHookOptions<ZendeskCallbackRequestCreateMutation, ZendeskCallbackRequestCreateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ZendeskCallbackRequestCreateMutation, ZendeskCallbackRequestCreateMutationVariables>(ZendeskCallbackRequestCreateDocument, options);
      }
export type ZendeskCallbackRequestCreateMutationHookResult = ReturnType<typeof useZendeskCallbackRequestCreateMutation>;
export type ZendeskCallbackRequestCreateMutationResult = Apollo.MutationResult<ZendeskCallbackRequestCreateMutation>;
export type ZendeskCallbackRequestCreateMutationOptions = Apollo.BaseMutationOptions<ZendeskCallbackRequestCreateMutation, ZendeskCallbackRequestCreateMutationVariables>;
export const DoorToDoorOnboardingReserveDocument = gql`
    mutation DoorToDoorOnboardingReserve($input: DoorToDoor__OnboardingInputType!) {
  result: doorToDoorOnboardingReserve(input: $input) {
    status
    error {
      ...error
    }
    orderToken
    orderID
    accountPortalUrl
  }
}
    ${ErrorFragmentDoc}`;
export type DoorToDoorOnboardingReserveMutationFn = Apollo.MutationFunction<DoorToDoorOnboardingReserveMutation, DoorToDoorOnboardingReserveMutationVariables>;

/**
 * __useDoorToDoorOnboardingReserveMutation__
 *
 * To run a mutation, you first call `useDoorToDoorOnboardingReserveMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDoorToDoorOnboardingReserveMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [doorToDoorOnboardingReserveMutation, { data, loading, error }] = useDoorToDoorOnboardingReserveMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDoorToDoorOnboardingReserveMutation(baseOptions?: Apollo.MutationHookOptions<DoorToDoorOnboardingReserveMutation, DoorToDoorOnboardingReserveMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DoorToDoorOnboardingReserveMutation, DoorToDoorOnboardingReserveMutationVariables>(DoorToDoorOnboardingReserveDocument, options);
      }
export type DoorToDoorOnboardingReserveMutationHookResult = ReturnType<typeof useDoorToDoorOnboardingReserveMutation>;
export type DoorToDoorOnboardingReserveMutationResult = Apollo.MutationResult<DoorToDoorOnboardingReserveMutation>;
export type DoorToDoorOnboardingReserveMutationOptions = Apollo.BaseMutationOptions<DoorToDoorOnboardingReserveMutation, DoorToDoorOnboardingReserveMutationVariables>;
export const DraftUpsertDocument = gql`
    mutation DraftUpsert($input: DraftInput!) {
  draftUpsert(input: $input) {
    status
    draft {
      ...draft
    }
  }
}
    ${DraftFragmentDoc}`;
export type DraftUpsertMutationFn = Apollo.MutationFunction<DraftUpsertMutation, DraftUpsertMutationVariables>;

/**
 * __useDraftUpsertMutation__
 *
 * To run a mutation, you first call `useDraftUpsertMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDraftUpsertMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [draftUpsertMutation, { data, loading, error }] = useDraftUpsertMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDraftUpsertMutation(baseOptions?: Apollo.MutationHookOptions<DraftUpsertMutation, DraftUpsertMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DraftUpsertMutation, DraftUpsertMutationVariables>(DraftUpsertDocument, options);
      }
export type DraftUpsertMutationHookResult = ReturnType<typeof useDraftUpsertMutation>;
export type DraftUpsertMutationResult = Apollo.MutationResult<DraftUpsertMutation>;
export type DraftUpsertMutationOptions = Apollo.BaseMutationOptions<DraftUpsertMutation, DraftUpsertMutationVariables>;
export const FlowStepTransitionDocument = gql`
    mutation FlowStepTransition($input: FlowStepTransitionInput!) {
  result: flowStepTransition(input: $input) {
    status
  }
}
    `;
export type FlowStepTransitionMutationFn = Apollo.MutationFunction<FlowStepTransitionMutation, FlowStepTransitionMutationVariables>;

/**
 * __useFlowStepTransitionMutation__
 *
 * To run a mutation, you first call `useFlowStepTransitionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useFlowStepTransitionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [flowStepTransitionMutation, { data, loading, error }] = useFlowStepTransitionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useFlowStepTransitionMutation(baseOptions?: Apollo.MutationHookOptions<FlowStepTransitionMutation, FlowStepTransitionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<FlowStepTransitionMutation, FlowStepTransitionMutationVariables>(FlowStepTransitionDocument, options);
      }
export type FlowStepTransitionMutationHookResult = ReturnType<typeof useFlowStepTransitionMutation>;
export type FlowStepTransitionMutationResult = Apollo.MutationResult<FlowStepTransitionMutation>;
export type FlowStepTransitionMutationOptions = Apollo.BaseMutationOptions<FlowStepTransitionMutation, FlowStepTransitionMutationVariables>;
export const LeadCreateDocument = gql`
    mutation LeadCreate($input: LeadInput!, $validateCustomerStatus: Boolean) {
  result: leadCreate(input: $input, validateCustomerStatus: $validateCustomerStatus) {
    lead {
      id
      currentStorageCustomer
      token
    }
    status
    error {
      ...error
    }
  }
}
    ${ErrorFragmentDoc}`;
export type LeadCreateMutationFn = Apollo.MutationFunction<LeadCreateMutation, LeadCreateMutationVariables>;

/**
 * __useLeadCreateMutation__
 *
 * To run a mutation, you first call `useLeadCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLeadCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [leadCreateMutation, { data, loading, error }] = useLeadCreateMutation({
 *   variables: {
 *      input: // value for 'input'
 *      validateCustomerStatus: // value for 'validateCustomerStatus'
 *   },
 * });
 */
export function useLeadCreateMutation(baseOptions?: Apollo.MutationHookOptions<LeadCreateMutation, LeadCreateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<LeadCreateMutation, LeadCreateMutationVariables>(LeadCreateDocument, options);
      }
export type LeadCreateMutationHookResult = ReturnType<typeof useLeadCreateMutation>;
export type LeadCreateMutationResult = Apollo.MutationResult<LeadCreateMutation>;
export type LeadCreateMutationOptions = Apollo.BaseMutationOptions<LeadCreateMutation, LeadCreateMutationVariables>;
export const MovingMaterialPackageSetEntriesFetchDocument = gql`
    mutation MovingMaterialPackageSetEntriesFetch($signedQuoteID: ID!) {
  materialPackageSetEntriesFetch(signedQuoteID: $signedQuoteID) {
    error
    status
    materialPackageSetEntries {
      ...Moving__materialPackageSetEntry
    }
  }
}
    ${Moving__MaterialPackageSetEntryFragmentDoc}`;
export type MovingMaterialPackageSetEntriesFetchMutationFn = Apollo.MutationFunction<MovingMaterialPackageSetEntriesFetchMutation, MovingMaterialPackageSetEntriesFetchMutationVariables>;

/**
 * __useMovingMaterialPackageSetEntriesFetchMutation__
 *
 * To run a mutation, you first call `useMovingMaterialPackageSetEntriesFetchMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMovingMaterialPackageSetEntriesFetchMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [movingMaterialPackageSetEntriesFetchMutation, { data, loading, error }] = useMovingMaterialPackageSetEntriesFetchMutation({
 *   variables: {
 *      signedQuoteID: // value for 'signedQuoteID'
 *   },
 * });
 */
export function useMovingMaterialPackageSetEntriesFetchMutation(baseOptions?: Apollo.MutationHookOptions<MovingMaterialPackageSetEntriesFetchMutation, MovingMaterialPackageSetEntriesFetchMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MovingMaterialPackageSetEntriesFetchMutation, MovingMaterialPackageSetEntriesFetchMutationVariables>(MovingMaterialPackageSetEntriesFetchDocument, options);
      }
export type MovingMaterialPackageSetEntriesFetchMutationHookResult = ReturnType<typeof useMovingMaterialPackageSetEntriesFetchMutation>;
export type MovingMaterialPackageSetEntriesFetchMutationResult = Apollo.MutationResult<MovingMaterialPackageSetEntriesFetchMutation>;
export type MovingMaterialPackageSetEntriesFetchMutationOptions = Apollo.BaseMutationOptions<MovingMaterialPackageSetEntriesFetchMutation, MovingMaterialPackageSetEntriesFetchMutationVariables>;
export const MfaAttemptMakeDocument = gql`
    mutation MFAAttemptMake($input: MFA__AttemptInput!) {
  mfaAttemptMake(input: $input) {
    lead {
      token
    }
    customer {
      token
    }
    error
    status
  }
}
    `;
export type MfaAttemptMakeMutationFn = Apollo.MutationFunction<MfaAttemptMakeMutation, MfaAttemptMakeMutationVariables>;

/**
 * __useMfaAttemptMakeMutation__
 *
 * To run a mutation, you first call `useMfaAttemptMakeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMfaAttemptMakeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [mfaAttemptMakeMutation, { data, loading, error }] = useMfaAttemptMakeMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useMfaAttemptMakeMutation(baseOptions?: Apollo.MutationHookOptions<MfaAttemptMakeMutation, MfaAttemptMakeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MfaAttemptMakeMutation, MfaAttemptMakeMutationVariables>(MfaAttemptMakeDocument, options);
      }
export type MfaAttemptMakeMutationHookResult = ReturnType<typeof useMfaAttemptMakeMutation>;
export type MfaAttemptMakeMutationResult = Apollo.MutationResult<MfaAttemptMakeMutation>;
export type MfaAttemptMakeMutationOptions = Apollo.BaseMutationOptions<MfaAttemptMakeMutation, MfaAttemptMakeMutationVariables>;
export const MfaRequestCreateDocument = gql`
    mutation MFARequestCreate($input: MFA__RequestInput!) {
  mfaRequestCreate(input: $input) {
    request {
      id
    }
    status
    error
  }
}
    `;
export type MfaRequestCreateMutationFn = Apollo.MutationFunction<MfaRequestCreateMutation, MfaRequestCreateMutationVariables>;

/**
 * __useMfaRequestCreateMutation__
 *
 * To run a mutation, you first call `useMfaRequestCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMfaRequestCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [mfaRequestCreateMutation, { data, loading, error }] = useMfaRequestCreateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useMfaRequestCreateMutation(baseOptions?: Apollo.MutationHookOptions<MfaRequestCreateMutation, MfaRequestCreateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MfaRequestCreateMutation, MfaRequestCreateMutationVariables>(MfaRequestCreateDocument, options);
      }
export type MfaRequestCreateMutationHookResult = ReturnType<typeof useMfaRequestCreateMutation>;
export type MfaRequestCreateMutationResult = Apollo.MutationResult<MfaRequestCreateMutation>;
export type MfaRequestCreateMutationOptions = Apollo.BaseMutationOptions<MfaRequestCreateMutation, MfaRequestCreateMutationVariables>;
export const MoveCreateDocument = gql`
    mutation MoveCreate($input: Moving__MoveInput!, $storagePlanInput: Moving__StoragePlanInput) {
  moveCreate(input: $input, storagePlanInput: $storagePlanInput) {
    status
    error {
      ...error
    }
    orderToken
    orderID
    accountPortalUrl
    isExistingCustomer
  }
}
    ${ErrorFragmentDoc}`;
export type MoveCreateMutationFn = Apollo.MutationFunction<MoveCreateMutation, MoveCreateMutationVariables>;

/**
 * __useMoveCreateMutation__
 *
 * To run a mutation, you first call `useMoveCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMoveCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [moveCreateMutation, { data, loading, error }] = useMoveCreateMutation({
 *   variables: {
 *      input: // value for 'input'
 *      storagePlanInput: // value for 'storagePlanInput'
 *   },
 * });
 */
export function useMoveCreateMutation(baseOptions?: Apollo.MutationHookOptions<MoveCreateMutation, MoveCreateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MoveCreateMutation, MoveCreateMutationVariables>(MoveCreateDocument, options);
      }
export type MoveCreateMutationHookResult = ReturnType<typeof useMoveCreateMutation>;
export type MoveCreateMutationResult = Apollo.MutationResult<MoveCreateMutation>;
export type MoveCreateMutationOptions = Apollo.BaseMutationOptions<MoveCreateMutation, MoveCreateMutationVariables>;
export const MovingQuoteCreateDocument = gql`
    mutation MovingQuoteCreate($input: Moving__QuoteInput!) {
  movingQuoteCreate(input: $input) {
    quote {
      ...movingQuote
    }
    status
    error
  }
}
    ${MovingQuoteFragmentDoc}`;
export type MovingQuoteCreateMutationFn = Apollo.MutationFunction<MovingQuoteCreateMutation, MovingQuoteCreateMutationVariables>;

/**
 * __useMovingQuoteCreateMutation__
 *
 * To run a mutation, you first call `useMovingQuoteCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMovingQuoteCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [movingQuoteCreateMutation, { data, loading, error }] = useMovingQuoteCreateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useMovingQuoteCreateMutation(baseOptions?: Apollo.MutationHookOptions<MovingQuoteCreateMutation, MovingQuoteCreateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MovingQuoteCreateMutation, MovingQuoteCreateMutationVariables>(MovingQuoteCreateDocument, options);
      }
export type MovingQuoteCreateMutationHookResult = ReturnType<typeof useMovingQuoteCreateMutation>;
export type MovingQuoteCreateMutationResult = Apollo.MutationResult<MovingQuoteCreateMutation>;
export type MovingQuoteCreateMutationOptions = Apollo.BaseMutationOptions<MovingQuoteCreateMutation, MovingQuoteCreateMutationVariables>;
export const ReviewSaveDocument = gql`
    mutation ReviewSave($input: ReviewInput!) {
  reviewSave(input: $input) {
    status
  }
}
    `;
export type ReviewSaveMutationFn = Apollo.MutationFunction<ReviewSaveMutation, ReviewSaveMutationVariables>;

/**
 * __useReviewSaveMutation__
 *
 * To run a mutation, you first call `useReviewSaveMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReviewSaveMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [reviewSaveMutation, { data, loading, error }] = useReviewSaveMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useReviewSaveMutation(baseOptions?: Apollo.MutationHookOptions<ReviewSaveMutation, ReviewSaveMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ReviewSaveMutation, ReviewSaveMutationVariables>(ReviewSaveDocument, options);
      }
export type ReviewSaveMutationHookResult = ReturnType<typeof useReviewSaveMutation>;
export type ReviewSaveMutationResult = Apollo.MutationResult<ReviewSaveMutation>;
export type ReviewSaveMutationOptions = Apollo.BaseMutationOptions<ReviewSaveMutation, ReviewSaveMutationVariables>;
export const AvailabilitiesDocument = gql`
    query Availabilities($input: AvailabilitiesInput!) {
  availabilities(input: $input) {
    ...availability
  }
}
    ${AvailabilityFragmentDoc}`;

/**
 * __useAvailabilitiesQuery__
 *
 * To run a query within a React component, call `useAvailabilitiesQuery` and pass it any options that fit your needs.
 * When your component renders, `useAvailabilitiesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAvailabilitiesQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAvailabilitiesQuery(baseOptions: Apollo.QueryHookOptions<AvailabilitiesQuery, AvailabilitiesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AvailabilitiesQuery, AvailabilitiesQueryVariables>(AvailabilitiesDocument, options);
      }
export function useAvailabilitiesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AvailabilitiesQuery, AvailabilitiesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AvailabilitiesQuery, AvailabilitiesQueryVariables>(AvailabilitiesDocument, options);
        }
export type AvailabilitiesQueryHookResult = ReturnType<typeof useAvailabilitiesQuery>;
export type AvailabilitiesLazyQueryHookResult = ReturnType<typeof useAvailabilitiesLazyQuery>;
export type AvailabilitiesQueryResult = Apollo.QueryResult<AvailabilitiesQuery, AvailabilitiesQueryVariables>;
export const CallbackWindowsDocument = gql`
    query CallbackWindows($department: CallbackDepartment) {
  callbackWindows(department: $department) {
    time
    duration
  }
  allowImmediateCallback(department: $department)
}
    `;

/**
 * __useCallbackWindowsQuery__
 *
 * To run a query within a React component, call `useCallbackWindowsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCallbackWindowsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCallbackWindowsQuery({
 *   variables: {
 *      department: // value for 'department'
 *   },
 * });
 */
export function useCallbackWindowsQuery(baseOptions?: Apollo.QueryHookOptions<CallbackWindowsQuery, CallbackWindowsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CallbackWindowsQuery, CallbackWindowsQueryVariables>(CallbackWindowsDocument, options);
      }
export function useCallbackWindowsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CallbackWindowsQuery, CallbackWindowsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CallbackWindowsQuery, CallbackWindowsQueryVariables>(CallbackWindowsDocument, options);
        }
export type CallbackWindowsQueryHookResult = ReturnType<typeof useCallbackWindowsQuery>;
export type CallbackWindowsLazyQueryHookResult = ReturnType<typeof useCallbackWindowsLazyQuery>;
export type CallbackWindowsQueryResult = Apollo.QueryResult<CallbackWindowsQuery, CallbackWindowsQueryVariables>;
export const CityDocument = gql`
    query City($state: ID!, $city: ID!, $service: Location__Service!) {
  state(slug: $state) {
    id
    slug
    name
    code
    city(slug: $city) {
      id
      slug
      name
      center {
        ...latLng
      }
      content(service: $service) {
        id
        title
        headline
        description
        blurb
        service
        heroAlt
        heroImage {
          id
          imgixURL
        }
        reviews {
          ...locationReview
        }
      }
      neighborhoods {
        id
        slug
        name
      }
    }
  }
}
    ${LatLngFragmentDoc}
${LocationReviewFragmentDoc}`;

/**
 * __useCityQuery__
 *
 * To run a query within a React component, call `useCityQuery` and pass it any options that fit your needs.
 * When your component renders, `useCityQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCityQuery({
 *   variables: {
 *      state: // value for 'state'
 *      city: // value for 'city'
 *      service: // value for 'service'
 *   },
 * });
 */
export function useCityQuery(baseOptions: Apollo.QueryHookOptions<CityQuery, CityQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CityQuery, CityQueryVariables>(CityDocument, options);
      }
export function useCityLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CityQuery, CityQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CityQuery, CityQueryVariables>(CityDocument, options);
        }
export type CityQueryHookResult = ReturnType<typeof useCityQuery>;
export type CityLazyQueryHookResult = ReturnType<typeof useCityLazyQuery>;
export type CityQueryResult = Apollo.QueryResult<CityQuery, CityQueryVariables>;
export const CouponDocument = gql`
    query Coupon($code: String!, $service: String) {
  coupon(code: $code, service: $service) {
    ... on Coupon {
      ...coupon
    }
    ... on Error {
      ...error
    }
  }
}
    ${CouponFragmentDoc}
${ErrorFragmentDoc}`;

/**
 * __useCouponQuery__
 *
 * To run a query within a React component, call `useCouponQuery` and pass it any options that fit your needs.
 * When your component renders, `useCouponQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCouponQuery({
 *   variables: {
 *      code: // value for 'code'
 *      service: // value for 'service'
 *   },
 * });
 */
export function useCouponQuery(baseOptions: Apollo.QueryHookOptions<CouponQuery, CouponQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CouponQuery, CouponQueryVariables>(CouponDocument, options);
      }
export function useCouponLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CouponQuery, CouponQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CouponQuery, CouponQueryVariables>(CouponDocument, options);
        }
export type CouponQueryHookResult = ReturnType<typeof useCouponQuery>;
export type CouponLazyQueryHookResult = ReturnType<typeof useCouponLazyQuery>;
export type CouponQueryResult = Apollo.QueryResult<CouponQuery, CouponQueryVariables>;
export const ReonboardingCustomerDocument = gql`
    query ReonboardingCustomer($customerToken: String!) {
  reonboardingCustomer(token: $customerToken) {
    id
    currentStorageCustomer
    name
    email
    phone
    address {
      zip
      street
      aptsuite
      city
      state
    }
    defaultSource {
      number
      fundingType
    }
  }
}
    `;

/**
 * __useReonboardingCustomerQuery__
 *
 * To run a query within a React component, call `useReonboardingCustomerQuery` and pass it any options that fit your needs.
 * When your component renders, `useReonboardingCustomerQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReonboardingCustomerQuery({
 *   variables: {
 *      customerToken: // value for 'customerToken'
 *   },
 * });
 */
export function useReonboardingCustomerQuery(baseOptions: Apollo.QueryHookOptions<ReonboardingCustomerQuery, ReonboardingCustomerQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ReonboardingCustomerQuery, ReonboardingCustomerQueryVariables>(ReonboardingCustomerDocument, options);
      }
export function useReonboardingCustomerLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ReonboardingCustomerQuery, ReonboardingCustomerQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ReonboardingCustomerQuery, ReonboardingCustomerQueryVariables>(ReonboardingCustomerDocument, options);
        }
export type ReonboardingCustomerQueryHookResult = ReturnType<typeof useReonboardingCustomerQuery>;
export type ReonboardingCustomerLazyQueryHookResult = ReturnType<typeof useReonboardingCustomerLazyQuery>;
export type ReonboardingCustomerQueryResult = Apollo.QueryResult<ReonboardingCustomerQuery, ReonboardingCustomerQueryVariables>;
export const DisposalCategoryPricingDocument = gql`
    query DisposalCategoryPricing {
  disposalCategoryPricing {
    category
    minimum
  }
}
    `;

/**
 * __useDisposalCategoryPricingQuery__
 *
 * To run a query within a React component, call `useDisposalCategoryPricingQuery` and pass it any options that fit your needs.
 * When your component renders, `useDisposalCategoryPricingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDisposalCategoryPricingQuery({
 *   variables: {
 *   },
 * });
 */
export function useDisposalCategoryPricingQuery(baseOptions?: Apollo.QueryHookOptions<DisposalCategoryPricingQuery, DisposalCategoryPricingQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DisposalCategoryPricingQuery, DisposalCategoryPricingQueryVariables>(DisposalCategoryPricingDocument, options);
      }
export function useDisposalCategoryPricingLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DisposalCategoryPricingQuery, DisposalCategoryPricingQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DisposalCategoryPricingQuery, DisposalCategoryPricingQueryVariables>(DisposalCategoryPricingDocument, options);
        }
export type DisposalCategoryPricingQueryHookResult = ReturnType<typeof useDisposalCategoryPricingQuery>;
export type DisposalCategoryPricingLazyQueryHookResult = ReturnType<typeof useDisposalCategoryPricingLazyQuery>;
export type DisposalCategoryPricingQueryResult = Apollo.QueryResult<DisposalCategoryPricingQuery, DisposalCategoryPricingQueryVariables>;
export const DraftDocument = gql`
    query Draft {
  draft {
    ...draft
  }
}
    ${DraftFragmentDoc}`;

/**
 * __useDraftQuery__
 *
 * To run a query within a React component, call `useDraftQuery` and pass it any options that fit your needs.
 * When your component renders, `useDraftQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDraftQuery({
 *   variables: {
 *   },
 * });
 */
export function useDraftQuery(baseOptions?: Apollo.QueryHookOptions<DraftQuery, DraftQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DraftQuery, DraftQueryVariables>(DraftDocument, options);
      }
export function useDraftLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DraftQuery, DraftQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DraftQuery, DraftQueryVariables>(DraftDocument, options);
        }
export type DraftQueryHookResult = ReturnType<typeof useDraftQuery>;
export type DraftLazyQueryHookResult = ReturnType<typeof useDraftLazyQuery>;
export type DraftQueryResult = Apollo.QueryResult<DraftQuery, DraftQueryVariables>;
export const EstimatedMoversDocument = gql`
    query EstimatedMovers($planId: ID!, $postalCode: String) {
  estimatedMovers(planId: $planId, postalCode: $postalCode)
}
    `;

/**
 * __useEstimatedMoversQuery__
 *
 * To run a query within a React component, call `useEstimatedMoversQuery` and pass it any options that fit your needs.
 * When your component renders, `useEstimatedMoversQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEstimatedMoversQuery({
 *   variables: {
 *      planId: // value for 'planId'
 *      postalCode: // value for 'postalCode'
 *   },
 * });
 */
export function useEstimatedMoversQuery(baseOptions: Apollo.QueryHookOptions<EstimatedMoversQuery, EstimatedMoversQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EstimatedMoversQuery, EstimatedMoversQueryVariables>(EstimatedMoversDocument, options);
      }
export function useEstimatedMoversLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EstimatedMoversQuery, EstimatedMoversQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EstimatedMoversQuery, EstimatedMoversQueryVariables>(EstimatedMoversDocument, options);
        }
export type EstimatedMoversQueryHookResult = ReturnType<typeof useEstimatedMoversQuery>;
export type EstimatedMoversLazyQueryHookResult = ReturnType<typeof useEstimatedMoversLazyQuery>;
export type EstimatedMoversQueryResult = Apollo.QueryResult<EstimatedMoversQuery, EstimatedMoversQueryVariables>;
export const FinalReturnCostSummariesDocument = gql`
    query FinalReturnCostSummaries($pricingSetId: ID!, $planIds: [ID!]!, $rateGroupKinds: [RateGroupKindEnum!]!) {
  result: pricingFinalReturnCostSummaries(pricingSetId: $pricingSetId, planIds: $planIds, rateGroupKinds: $rateGroupKinds) {
    ...finalReturnCostSummary
  }
}
    ${FinalReturnCostSummaryFragmentDoc}`;

/**
 * __useFinalReturnCostSummariesQuery__
 *
 * To run a query within a React component, call `useFinalReturnCostSummariesQuery` and pass it any options that fit your needs.
 * When your component renders, `useFinalReturnCostSummariesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFinalReturnCostSummariesQuery({
 *   variables: {
 *      pricingSetId: // value for 'pricingSetId'
 *      planIds: // value for 'planIds'
 *      rateGroupKinds: // value for 'rateGroupKinds'
 *   },
 * });
 */
export function useFinalReturnCostSummariesQuery(baseOptions: Apollo.QueryHookOptions<FinalReturnCostSummariesQuery, FinalReturnCostSummariesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FinalReturnCostSummariesQuery, FinalReturnCostSummariesQueryVariables>(FinalReturnCostSummariesDocument, options);
      }
export function useFinalReturnCostSummariesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FinalReturnCostSummariesQuery, FinalReturnCostSummariesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FinalReturnCostSummariesQuery, FinalReturnCostSummariesQueryVariables>(FinalReturnCostSummariesDocument, options);
        }
export type FinalReturnCostSummariesQueryHookResult = ReturnType<typeof useFinalReturnCostSummariesQuery>;
export type FinalReturnCostSummariesLazyQueryHookResult = ReturnType<typeof useFinalReturnCostSummariesLazyQuery>;
export type FinalReturnCostSummariesQueryResult = Apollo.QueryResult<FinalReturnCostSummariesQuery, FinalReturnCostSummariesQueryVariables>;
export const GeocodeDocument = gql`
    query Geocode($zip: String!) {
  geocode(zip: $zip) {
    ...geocode
  }
}
    ${GeocodeFragmentDoc}`;

/**
 * __useGeocodeQuery__
 *
 * To run a query within a React component, call `useGeocodeQuery` and pass it any options that fit your needs.
 * When your component renders, `useGeocodeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGeocodeQuery({
 *   variables: {
 *      zip: // value for 'zip'
 *   },
 * });
 */
export function useGeocodeQuery(baseOptions: Apollo.QueryHookOptions<GeocodeQuery, GeocodeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GeocodeQuery, GeocodeQueryVariables>(GeocodeDocument, options);
      }
export function useGeocodeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GeocodeQuery, GeocodeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GeocodeQuery, GeocodeQueryVariables>(GeocodeDocument, options);
        }
export type GeocodeQueryHookResult = ReturnType<typeof useGeocodeQuery>;
export type GeocodeLazyQueryHookResult = ReturnType<typeof useGeocodeLazyQuery>;
export type GeocodeQueryResult = Apollo.QueryResult<GeocodeQuery, GeocodeQueryVariables>;
export const IsExistingCustomerDocument = gql`
    query IsExistingCustomer($email: String!, $phoneNumber: String!) {
  isExistingCustomer(email: $email, phoneNumber: $phoneNumber)
}
    `;

/**
 * __useIsExistingCustomerQuery__
 *
 * To run a query within a React component, call `useIsExistingCustomerQuery` and pass it any options that fit your needs.
 * When your component renders, `useIsExistingCustomerQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useIsExistingCustomerQuery({
 *   variables: {
 *      email: // value for 'email'
 *      phoneNumber: // value for 'phoneNumber'
 *   },
 * });
 */
export function useIsExistingCustomerQuery(baseOptions: Apollo.QueryHookOptions<IsExistingCustomerQuery, IsExistingCustomerQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IsExistingCustomerQuery, IsExistingCustomerQueryVariables>(IsExistingCustomerDocument, options);
      }
export function useIsExistingCustomerLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IsExistingCustomerQuery, IsExistingCustomerQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IsExistingCustomerQuery, IsExistingCustomerQueryVariables>(IsExistingCustomerDocument, options);
        }
export type IsExistingCustomerQueryHookResult = ReturnType<typeof useIsExistingCustomerQuery>;
export type IsExistingCustomerLazyQueryHookResult = ReturnType<typeof useIsExistingCustomerLazyQuery>;
export type IsExistingCustomerQueryResult = Apollo.QueryResult<IsExistingCustomerQuery, IsExistingCustomerQueryVariables>;
export const LeadDocument = gql`
    query Lead($token: ID!) {
  lead(token: $token) {
    ...lead
  }
}
    ${LeadFragmentDoc}`;

/**
 * __useLeadQuery__
 *
 * To run a query within a React component, call `useLeadQuery` and pass it any options that fit your needs.
 * When your component renders, `useLeadQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLeadQuery({
 *   variables: {
 *      token: // value for 'token'
 *   },
 * });
 */
export function useLeadQuery(baseOptions: Apollo.QueryHookOptions<LeadQuery, LeadQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<LeadQuery, LeadQueryVariables>(LeadDocument, options);
      }
export function useLeadLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LeadQuery, LeadQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<LeadQuery, LeadQueryVariables>(LeadDocument, options);
        }
export type LeadQueryHookResult = ReturnType<typeof useLeadQuery>;
export type LeadLazyQueryHookResult = ReturnType<typeof useLeadLazyQuery>;
export type LeadQueryResult = Apollo.QueryResult<LeadQuery, LeadQueryVariables>;
export const LocationLinksDocument = gql`
    query LocationLinks {
  states {
    id
    code
    name
    slug
    cities {
      id
      slug
      name
      services
      center {
        ...latLng
      }
    }
  }
}
    ${LatLngFragmentDoc}`;

/**
 * __useLocationLinksQuery__
 *
 * To run a query within a React component, call `useLocationLinksQuery` and pass it any options that fit your needs.
 * When your component renders, `useLocationLinksQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLocationLinksQuery({
 *   variables: {
 *   },
 * });
 */
export function useLocationLinksQuery(baseOptions?: Apollo.QueryHookOptions<LocationLinksQuery, LocationLinksQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<LocationLinksQuery, LocationLinksQueryVariables>(LocationLinksDocument, options);
      }
export function useLocationLinksLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LocationLinksQuery, LocationLinksQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<LocationLinksQuery, LocationLinksQueryVariables>(LocationLinksDocument, options);
        }
export type LocationLinksQueryHookResult = ReturnType<typeof useLocationLinksQuery>;
export type LocationLinksLazyQueryHookResult = ReturnType<typeof useLocationLinksLazyQuery>;
export type LocationLinksQueryResult = Apollo.QueryResult<LocationLinksQuery, LocationLinksQueryVariables>;
export const LongDistanceAvailabilitiesDocument = gql`
    query LongDistanceAvailabilities($input: AvailabilitiesInput!) {
  availabilities: longDistanceAvailabilities(input: $input) {
    ...multidayAvailability
  }
}
    ${MultidayAvailabilityFragmentDoc}`;

/**
 * __useLongDistanceAvailabilitiesQuery__
 *
 * To run a query within a React component, call `useLongDistanceAvailabilitiesQuery` and pass it any options that fit your needs.
 * When your component renders, `useLongDistanceAvailabilitiesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLongDistanceAvailabilitiesQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useLongDistanceAvailabilitiesQuery(baseOptions: Apollo.QueryHookOptions<LongDistanceAvailabilitiesQuery, LongDistanceAvailabilitiesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<LongDistanceAvailabilitiesQuery, LongDistanceAvailabilitiesQueryVariables>(LongDistanceAvailabilitiesDocument, options);
      }
export function useLongDistanceAvailabilitiesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LongDistanceAvailabilitiesQuery, LongDistanceAvailabilitiesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<LongDistanceAvailabilitiesQuery, LongDistanceAvailabilitiesQueryVariables>(LongDistanceAvailabilitiesDocument, options);
        }
export type LongDistanceAvailabilitiesQueryHookResult = ReturnType<typeof useLongDistanceAvailabilitiesQuery>;
export type LongDistanceAvailabilitiesLazyQueryHookResult = ReturnType<typeof useLongDistanceAvailabilitiesLazyQuery>;
export type LongDistanceAvailabilitiesQueryResult = Apollo.QueryResult<LongDistanceAvailabilitiesQuery, LongDistanceAvailabilitiesQueryVariables>;
export const MovingRouteSummaryDocument = gql`
    query MovingRouteSummary($destinationAddress: AddressInput!, $originAddress: AddressInput!, $unitTypes: UnitTypes, $moveSize: Moving__MoveSizeEnum) {
  movingRouteSummary(destinationAddress: $destinationAddress, originAddress: $originAddress, unitTypes: $unitTypes, moveSize: $moveSize) {
    validMoveRoute
    longDistance
    extendedDestinationServiceArea
  }
}
    `;

/**
 * __useMovingRouteSummaryQuery__
 *
 * To run a query within a React component, call `useMovingRouteSummaryQuery` and pass it any options that fit your needs.
 * When your component renders, `useMovingRouteSummaryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMovingRouteSummaryQuery({
 *   variables: {
 *      destinationAddress: // value for 'destinationAddress'
 *      originAddress: // value for 'originAddress'
 *      unitTypes: // value for 'unitTypes'
 *      moveSize: // value for 'moveSize'
 *   },
 * });
 */
export function useMovingRouteSummaryQuery(baseOptions: Apollo.QueryHookOptions<MovingRouteSummaryQuery, MovingRouteSummaryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MovingRouteSummaryQuery, MovingRouteSummaryQueryVariables>(MovingRouteSummaryDocument, options);
      }
export function useMovingRouteSummaryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MovingRouteSummaryQuery, MovingRouteSummaryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MovingRouteSummaryQuery, MovingRouteSummaryQueryVariables>(MovingRouteSummaryDocument, options);
        }
export type MovingRouteSummaryQueryHookResult = ReturnType<typeof useMovingRouteSummaryQuery>;
export type MovingRouteSummaryLazyQueryHookResult = ReturnType<typeof useMovingRouteSummaryLazyQuery>;
export type MovingRouteSummaryQueryResult = Apollo.QueryResult<MovingRouteSummaryQuery, MovingRouteSummaryQueryVariables>;
export const NeighborhoodDocument = gql`
    query Neighborhood($state: ID!, $city: ID!, $neighborhood: ID!, $service: Location__Service!) {
  state(slug: $state) {
    id
    slug
    name
    code
    city(slug: $city) {
      id
      slug
      name
      center {
        ...latLng
      }
      content(service: $service) {
        reviews {
          ...locationReview
        }
      }
      neighborhood(slug: $neighborhood) {
        id
        slug
        name
        content(service: $service) {
          id
          title
          headline
          description
          blurb
          service
          heroAlt
          heroImage {
            id
            imgixURL
          }
          reviews {
            ...locationReview
          }
        }
      }
      neighborhoods {
        id
        slug
        name
      }
    }
  }
}
    ${LatLngFragmentDoc}
${LocationReviewFragmentDoc}`;

/**
 * __useNeighborhoodQuery__
 *
 * To run a query within a React component, call `useNeighborhoodQuery` and pass it any options that fit your needs.
 * When your component renders, `useNeighborhoodQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useNeighborhoodQuery({
 *   variables: {
 *      state: // value for 'state'
 *      city: // value for 'city'
 *      neighborhood: // value for 'neighborhood'
 *      service: // value for 'service'
 *   },
 * });
 */
export function useNeighborhoodQuery(baseOptions: Apollo.QueryHookOptions<NeighborhoodQuery, NeighborhoodQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<NeighborhoodQuery, NeighborhoodQueryVariables>(NeighborhoodDocument, options);
      }
export function useNeighborhoodLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<NeighborhoodQuery, NeighborhoodQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<NeighborhoodQuery, NeighborhoodQueryVariables>(NeighborhoodDocument, options);
        }
export type NeighborhoodQueryHookResult = ReturnType<typeof useNeighborhoodQuery>;
export type NeighborhoodLazyQueryHookResult = ReturnType<typeof useNeighborhoodLazyQuery>;
export type NeighborhoodQueryResult = Apollo.QueryResult<NeighborhoodQuery, NeighborhoodQueryVariables>;
export const OnboardingCostSummariesDocument = gql`
    query OnboardingCostSummaries($pricingSetId: ID!, $planIds: [ID!]!, $rateGroupKinds: [RateGroupKindEnum!]!) {
  result: pricingOnboardingCostSummaries(pricingSetId: $pricingSetId, planIds: $planIds, rateGroupKinds: $rateGroupKinds) {
    ...onboardingCostSummary
  }
}
    ${OnboardingCostSummaryFragmentDoc}`;

/**
 * __useOnboardingCostSummariesQuery__
 *
 * To run a query within a React component, call `useOnboardingCostSummariesQuery` and pass it any options that fit your needs.
 * When your component renders, `useOnboardingCostSummariesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOnboardingCostSummariesQuery({
 *   variables: {
 *      pricingSetId: // value for 'pricingSetId'
 *      planIds: // value for 'planIds'
 *      rateGroupKinds: // value for 'rateGroupKinds'
 *   },
 * });
 */
export function useOnboardingCostSummariesQuery(baseOptions: Apollo.QueryHookOptions<OnboardingCostSummariesQuery, OnboardingCostSummariesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OnboardingCostSummariesQuery, OnboardingCostSummariesQueryVariables>(OnboardingCostSummariesDocument, options);
      }
export function useOnboardingCostSummariesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OnboardingCostSummariesQuery, OnboardingCostSummariesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OnboardingCostSummariesQuery, OnboardingCostSummariesQueryVariables>(OnboardingCostSummariesDocument, options);
        }
export type OnboardingCostSummariesQueryHookResult = ReturnType<typeof useOnboardingCostSummariesQuery>;
export type OnboardingCostSummariesLazyQueryHookResult = ReturnType<typeof useOnboardingCostSummariesLazyQuery>;
export type OnboardingCostSummariesQueryResult = Apollo.QueryResult<OnboardingCostSummariesQuery, OnboardingCostSummariesQueryVariables>;
export const PricingSetDocument = gql`
    query PricingSet($zip: String!, $visitorToken: String!) {
  pricingSet(zip: $zip, visitorToken: $visitorToken) {
    ...pricingSet
  }
}
    ${PricingSetFragmentDoc}`;

/**
 * __usePricingSetQuery__
 *
 * To run a query within a React component, call `usePricingSetQuery` and pass it any options that fit your needs.
 * When your component renders, `usePricingSetQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePricingSetQuery({
 *   variables: {
 *      zip: // value for 'zip'
 *      visitorToken: // value for 'visitorToken'
 *   },
 * });
 */
export function usePricingSetQuery(baseOptions: Apollo.QueryHookOptions<PricingSetQuery, PricingSetQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PricingSetQuery, PricingSetQueryVariables>(PricingSetDocument, options);
      }
export function usePricingSetLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PricingSetQuery, PricingSetQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PricingSetQuery, PricingSetQueryVariables>(PricingSetDocument, options);
        }
export type PricingSetQueryHookResult = ReturnType<typeof usePricingSetQuery>;
export type PricingSetLazyQueryHookResult = ReturnType<typeof usePricingSetLazyQuery>;
export type PricingSetQueryResult = Apollo.QueryResult<PricingSetQuery, PricingSetQueryVariables>;
export const QualfiedContactTopicsDocument = gql`
    query QualfiedContactTopics {
  topics: qualifiedContactTopics {
    ...qualifiedContentTopic
  }
}
    ${QualifiedContentTopicFragmentDoc}`;

/**
 * __useQualfiedContactTopicsQuery__
 *
 * To run a query within a React component, call `useQualfiedContactTopicsQuery` and pass it any options that fit your needs.
 * When your component renders, `useQualfiedContactTopicsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useQualfiedContactTopicsQuery({
 *   variables: {
 *   },
 * });
 */
export function useQualfiedContactTopicsQuery(baseOptions?: Apollo.QueryHookOptions<QualfiedContactTopicsQuery, QualfiedContactTopicsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<QualfiedContactTopicsQuery, QualfiedContactTopicsQueryVariables>(QualfiedContactTopicsDocument, options);
      }
export function useQualfiedContactTopicsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<QualfiedContactTopicsQuery, QualfiedContactTopicsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<QualfiedContactTopicsQuery, QualfiedContactTopicsQueryVariables>(QualfiedContactTopicsDocument, options);
        }
export type QualfiedContactTopicsQueryHookResult = ReturnType<typeof useQualfiedContactTopicsQuery>;
export type QualfiedContactTopicsLazyQueryHookResult = ReturnType<typeof useQualfiedContactTopicsLazyQuery>;
export type QualfiedContactTopicsQueryResult = Apollo.QueryResult<QualfiedContactTopicsQuery, QualfiedContactTopicsQueryVariables>;
export const ReferralDocument = gql`
    query Referral($promoCode: String!) {
  referral(promoCode: $promoCode) {
    ...referralPromo
  }
}
    ${ReferralPromoFragmentDoc}`;

/**
 * __useReferralQuery__
 *
 * To run a query within a React component, call `useReferralQuery` and pass it any options that fit your needs.
 * When your component renders, `useReferralQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReferralQuery({
 *   variables: {
 *      promoCode: // value for 'promoCode'
 *   },
 * });
 */
export function useReferralQuery(baseOptions: Apollo.QueryHookOptions<ReferralQuery, ReferralQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ReferralQuery, ReferralQueryVariables>(ReferralDocument, options);
      }
export function useReferralLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ReferralQuery, ReferralQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ReferralQuery, ReferralQueryVariables>(ReferralDocument, options);
        }
export type ReferralQueryHookResult = ReturnType<typeof useReferralQuery>;
export type ReferralLazyQueryHookResult = ReturnType<typeof useReferralLazyQuery>;
export type ReferralQueryResult = Apollo.QueryResult<ReferralQuery, ReferralQueryVariables>;
export const RouteDocument = gql`
    query Route($route: ID!, $service: Location__Service!) {
  route(slug: $route) {
    id
    slug
    content(service: $service) {
      id
      title
      headline
      description
      blurb
      service
      heroAlt
      heroImage {
        id
        imgixURL
      }
      reviews {
        ...locationReview
      }
    }
    origin {
      ... on Location__State {
        id
        name
        code
        slug
      }
      ... on Location__City {
        id
        name
        slug
        center {
          ...latLng
        }
        state {
          id
          name
          code
          slug
        }
        content(service: $service) {
          reviews {
            ...locationReview
          }
        }
        neighborhoods {
          id
          slug
          name
        }
      }
      ... on Location__Neighborhood {
        id
        name
        slug
        city {
          id
          name
          slug
          center {
            ...latLng
          }
          state {
            id
            name
            code
            slug
          }
          neighborhoods {
            id
            slug
            name
          }
        }
        content(service: $service) {
          reviews {
            ...locationReview
          }
        }
      }
    }
    destination {
      ... on Location__State {
        id
        name
      }
      ... on Location__City {
        id
        name
        state {
          id
          name
        }
      }
      ... on Location__Neighborhood {
        id
        name
        city {
          id
          name
          state {
            id
            name
          }
        }
      }
    }
  }
}
    ${LocationReviewFragmentDoc}
${LatLngFragmentDoc}`;

/**
 * __useRouteQuery__
 *
 * To run a query within a React component, call `useRouteQuery` and pass it any options that fit your needs.
 * When your component renders, `useRouteQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRouteQuery({
 *   variables: {
 *      route: // value for 'route'
 *      service: // value for 'service'
 *   },
 * });
 */
export function useRouteQuery(baseOptions: Apollo.QueryHookOptions<RouteQuery, RouteQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<RouteQuery, RouteQueryVariables>(RouteDocument, options);
      }
export function useRouteLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<RouteQuery, RouteQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<RouteQuery, RouteQueryVariables>(RouteDocument, options);
        }
export type RouteQueryHookResult = ReturnType<typeof useRouteQuery>;
export type RouteLazyQueryHookResult = ReturnType<typeof useRouteLazyQuery>;
export type RouteQueryResult = Apollo.QueryResult<RouteQuery, RouteQueryVariables>;
export const SalesTaxDocument = gql`
    query SalesTax($zipCode: String!) {
  salesTax(zipCode: $zipCode) {
    percent
  }
}
    `;

/**
 * __useSalesTaxQuery__
 *
 * To run a query within a React component, call `useSalesTaxQuery` and pass it any options that fit your needs.
 * When your component renders, `useSalesTaxQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSalesTaxQuery({
 *   variables: {
 *      zipCode: // value for 'zipCode'
 *   },
 * });
 */
export function useSalesTaxQuery(baseOptions: Apollo.QueryHookOptions<SalesTaxQuery, SalesTaxQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SalesTaxQuery, SalesTaxQueryVariables>(SalesTaxDocument, options);
      }
export function useSalesTaxLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SalesTaxQuery, SalesTaxQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SalesTaxQuery, SalesTaxQueryVariables>(SalesTaxDocument, options);
        }
export type SalesTaxQueryHookResult = ReturnType<typeof useSalesTaxQuery>;
export type SalesTaxLazyQueryHookResult = ReturnType<typeof useSalesTaxLazyQuery>;
export type SalesTaxQueryResult = Apollo.QueryResult<SalesTaxQuery, SalesTaxQueryVariables>;
export const SeoRegionPolygonDocument = gql`
    query SeoRegionPolygon($state: ID!, $city: ID!) {
  state(slug: $state) {
    id
    city(slug: $city) {
      id
      polygons {
        paths {
          ...latLng
        }
      }
    }
  }
}
    ${LatLngFragmentDoc}`;

/**
 * __useSeoRegionPolygonQuery__
 *
 * To run a query within a React component, call `useSeoRegionPolygonQuery` and pass it any options that fit your needs.
 * When your component renders, `useSeoRegionPolygonQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSeoRegionPolygonQuery({
 *   variables: {
 *      state: // value for 'state'
 *      city: // value for 'city'
 *   },
 * });
 */
export function useSeoRegionPolygonQuery(baseOptions: Apollo.QueryHookOptions<SeoRegionPolygonQuery, SeoRegionPolygonQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SeoRegionPolygonQuery, SeoRegionPolygonQueryVariables>(SeoRegionPolygonDocument, options);
      }
export function useSeoRegionPolygonLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SeoRegionPolygonQuery, SeoRegionPolygonQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SeoRegionPolygonQuery, SeoRegionPolygonQueryVariables>(SeoRegionPolygonDocument, options);
        }
export type SeoRegionPolygonQueryHookResult = ReturnType<typeof useSeoRegionPolygonQuery>;
export type SeoRegionPolygonLazyQueryHookResult = ReturnType<typeof useSeoRegionPolygonLazyQuery>;
export type SeoRegionPolygonQueryResult = Apollo.QueryResult<SeoRegionPolygonQuery, SeoRegionPolygonQueryVariables>;
export const StorageBundlesDocument = gql`
    query StorageBundles($cuft: Int) {
  bundles: pricingBundles(cuft: $cuft) {
    ...storageBundle
  }
}
    ${StorageBundleFragmentDoc}`;

/**
 * __useStorageBundlesQuery__
 *
 * To run a query within a React component, call `useStorageBundlesQuery` and pass it any options that fit your needs.
 * When your component renders, `useStorageBundlesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStorageBundlesQuery({
 *   variables: {
 *      cuft: // value for 'cuft'
 *   },
 * });
 */
export function useStorageBundlesQuery(baseOptions?: Apollo.QueryHookOptions<StorageBundlesQuery, StorageBundlesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<StorageBundlesQuery, StorageBundlesQueryVariables>(StorageBundlesDocument, options);
      }
export function useStorageBundlesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<StorageBundlesQuery, StorageBundlesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<StorageBundlesQuery, StorageBundlesQueryVariables>(StorageBundlesDocument, options);
        }
export type StorageBundlesQueryHookResult = ReturnType<typeof useStorageBundlesQuery>;
export type StorageBundlesLazyQueryHookResult = ReturnType<typeof useStorageBundlesLazyQuery>;
export type StorageBundlesQueryResult = Apollo.QueryResult<StorageBundlesQuery, StorageBundlesQueryVariables>;